// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-07T17:15:14.006Z
// Property: The Pointe (ID: 6737460151191771)
// Collections: 40 amenities, 17 floorplans (live), 64 photos, 75 POIs, 4 reviews, 1 virtual tours, 5 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6737460151191771",
  "property_external_id": "4709053",
  "property_zillow_url": "https://www.zillow.com/b/pointe-townhomes-beaumont-tx-5Xt4Q2/",
  "property_apartments_url": "https://www.apartments.com/the-pointe-beaumont-tx/0rgnzx2",
  "property_google_business_url": "https://www.google.com/maps/place/The+Pointe/data=!4m2!3m1!1s0x0:0x4d53715da3605434?sa=X&ved=2ahUKEwij2PLyv7ySAxUyrYkEHeOcMhgQ_BJ6BAhGEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "4271722839",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "the-pointe",
  "property_name": "The Pointe",
  "property_website_url": "https://www.thepointeapthome.com/",
  "property_domain": "https://www.thepointeapthome.com/",
  "property_address": "4165 Old Dowlen Rd",
  "property_full_address": "4165 Old Dowlen Rd, Beaumont, TX 77706",
  "property_address_1": "4165 Old Dowlen Rd",
  "property_address_2": null,
  "property_address_city": "Beaumont",
  "property_address_state": "TX",
  "property_address_zip_full": "77706-6608",
  "property_address_zip": "77706",
  "property_address_country": "US",
  "property_address_county": "Jefferson County",
  "property_neighborhood_address": "North Beaumont",
  "property_address_latitude": "30.1228763",
  "property_address_longitude": "-94.1708941",
  "property_email": "pointe@rreafresidential.com",
  "property_phone": "(409) 924-9000",
  "property_call_tracking_phone": "409-345-2866",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to The Pointe in Beaumont, TX, where comfort meets convenience! Choose from our spacious one and two-bedroom floor plans, and enjoy top-notch amenities including a pool, fitness center, playground, and gated access. Find your new home today—browse our availability or schedule a tour to discover your perfect fit!",
  "property_long_description": "**Welcome to The Pointe – Your Ideal Beaumont Apartment Community!**\n\nDiscover modern living at The Pointe in beautiful Beaumont, TX, where comfort meets convenience. Our inviting apartment community offers a variety of thoughtfully designed floor plans tailored to suit your lifestyle, including spacious one-bedroom and two-bedroom options. Each apartment is crafted with contemporary finishes, providing a cozy sanctuary you're proud to call home.\n\nAt The Pointe, we prioritize your safety and well-being with amenities designed for peace of mind. Our dedicated night patrol ensures that you and your loved ones feel secure at all times. Enjoy warm afternoons lounging by our sparkling pool, or unwind with family and friends at the playground. Plus, rest easy knowing our secure gated entrance and covered parking enhance your living experience.\n\nStay active and energized in our state-of-the-art fitness center, complete with all the equipment you need to maintain your healthy lifestyle. For your convenience, on-site laundry facilities make everyday chores a breeze, so you can spend more time enjoying your surroundings.\n\nExperience the perfect blend of relaxation, recreation, and community at The Pointe. Located just minutes away from local dining, shopping, and entertainment options, you'll find everything you need right at your doorstep. \n\nDon’t wait—your dream apartment is waiting for you! Browse our availability today or schedule a tour to see why The Pointe is the perfect place to call home. Welcome to your new lifestyle in Beaumont, TX!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-6353-72b9-8bf9-bf6da4671777.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool with lounge chairs and a playground.",
    "public_id": "019e84cc-6353-72b9-8bf9-bf6da4671777",
    "storage_key": "property/6737460151191771/019e84cc-6353-72b9-8bf9-bf6da4671777.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "152",
  "property_year_built": "2001",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "92.76315789473685",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": null,
  "property_pet_deposit": null,
  "property_monthly_pet_rent": null,
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Cats and dogs allowed. No breed restrictions. Maximum of 2 pets per home.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://thepointeapthome.loftliving.com/login",
  "property_apply_now_url": "https://8451243aff.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-3821-753c-bac9-891defeb7afe.webp",
  "property_primary_logo_media": {
    "alt_text": "The Pointe Apartment Homes logo",
    "public_id": "019e1e1e-3821-753c-bac9-891defeb7afe",
    "storage_key": "property/6737460151191771/019e1e1e-3821-753c-bac9-891defeb7afe.webp",
    "width": 1982,
    "height": 513
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-3806-7337-9ed6-ec8370eef64e.webp",
  "property_secondary_logo_media": {
    "alt_text": "The Pointe Apartment Homes logo",
    "public_id": "019e1e1e-3806-7337-9ed6-ec8370eef64e",
    "storage_key": "property/6737460151191771/019e1e1e-3806-7337-9ed6-ec8370eef64e.webp",
    "width": 1983,
    "height": 517
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-3806-7337-9ed6-ec8370eef64e.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Pointe Apartment Homes logo",
    "public_id": "019e1e1e-3806-7337-9ed6-ec8370eef64e",
    "storage_key": "property/6737460151191771/019e1e1e-3806-7337-9ed6-ec8370eef64e.webp",
    "width": 1983,
    "height": 517
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-3821-753c-bac9-891defeb7afe.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Pointe Apartment Homes logo",
    "public_id": "019e1e1e-3821-753c-bac9-891defeb7afe",
    "storage_key": "property/6737460151191771/019e1e1e-3821-753c-bac9-891defeb7afe.webp",
    "width": 1982,
    "height": 513
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#a2a569",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#a2a569",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "667 - 1232",
  "property_sqft_min": "667",
  "property_sqft_max": "1232",
  "property_price_range": "1099 - 1699",
  "property_price_min": "1099",
  "property_price_max": "1699",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/people/The-Pointe/61554027039802/",
  "property_instagram_url": "https://www.instagram.com/the_pointe_rrliving/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJw_y5sXIzOYYRNFRgo11xU00",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/the-pointe-apartments-beaumont",
  "property_tiktok_url": "https://www.tiktok.com/@the.pointe.apts",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to The Pointe",
  "property_home_romance_title": "Embrace a Life of Love and Comfort at Our Community",
  "property_home_amenities_blurb": "<p>The residences of The Pointe apartments present a compelling portrait of refined living. Our pet-friendly community strives to <a href=\"/amenities/\">give you plenty of activities</a> for you to do in our grand clubhouse, a business center, our resident fitness center, a bark park, and our outdoor resort-style swimming pool. There is even a play area and picnic area with a barbecue surrounded by <a href=\"/gallery/\">beautiful landscaping</a>, perfect for a family gathering.</p>",
  "property_home_floorplans_blurb": "<p>Located by Highway 287, <a href=\"/floor-plans/\">The Pointe apartments</a> are ideally situated minutes from State Route 69. This unbeatable location provides access to tempting dining spots and exciting entertainment venues. Bike trails, skate parks, and many sophisticated shopping centers are also within walking distance. Accompanied by breathtaking views, this community has all the fun that Beaumont, TX, has to offer, nestled in a quiet, tree lined neighborhood.</p>",
  "property_home_gallery_blurb": "At The Pointe in Beaumont, TX, your ideal home awaits—choose from spacious one and two-bedroom floor plans designed for comfort. Enjoy resort-style amenities like a shimmering pool, a lively bark park, and a community-focused atmosphere. Picture yourself living here, where convenience meets luxury in every detail.",
  "property_home_neighborhood_blurb": "Discover the vibrant neighborhood around The Pointe in Beaumont, TX! Choose from our spacious one or two-bedroom floor plans and embrace the local charm. See what's around our community and explore local favorites and nearby points of interest that make living here truly special. Start your adventure today!",
  "property_home_reviews_blurb": "At The Pointe in Beaumont, TX, residents rave about our spacious floorplans and top-notch amenities. With a neighborhood feel and standout townhouse layouts, you’ll find comfort and style here. One resident says, “Every time I needed something, they took care of it next day.” Experience our exceptional community today!",
  "property_neighborhood_blurb": "<p>Located by Highway 287, <a href=\"/floor-plans/\">The Pointe apartments</a> are ideally situated minutes from State Route 69. This unbeatable location provides access to tempting dining spots and exciting entertainment venues. Bike trails, skate parks, and many sophisticated shopping centers are also within walking distance. Accompanied by breathtaking views, this community has all the fun that Beaumont, TX, has to offer, nestled in a quiet, tree lined neighborhood.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Unmatched in high-end comforts and signature amenities, The Pointe offers a variety of spacious floor plans from our <a href=\"/floor-plans/\">one-two bedroom apartments</a> to our <a href=\"/floor-plans/\">two bedroom townhomes</a> for rent in <a href=\"/neighborhood/\">Beaumont, Texas.</a> Experience an “at home” feeling with black appliances, plank flooring, ceiling fans, and an in-home washer and dryer for your convenience.</p>\n<p>Within our tranquil community adorned with lush landscaping, enjoy amenities like our playground and a bark park for your furry friends. Or, venture out to our vibrant Beaumont neighborhood where you can indulge in the area's best dining, shopping centers, and entertainment all within minutes away. It's time to make The Pointe your dream home and open the door to new possibilities!</p>",
  "property_applynow_blurb": "Discover your ideal apartment at The Pointe in Beaumont, TX. Choose from spacious one and two-bedroom floor plans, while enjoying exceptional amenities like a pool, fitness center, playground, and night patrol for added peace of mind. Don’t wait—find your new home and lease online today!",
  "property_contactus_blurb": "Discover your perfect living space at The Pointe in Beaumont, TX! Choose from our stylish one and two-bedroom floor plans designed for comfort and convenience. Explore our diverse layouts and envision your new home. Have questions? Contact our leasing team today to learn more about our vibrant community!",
  "property_faqs_blurb": "At The Pointe in Beaumont, TX, we offer a variety of spacious floor plans, including one and two-bedroom apartments to suit your lifestyle. Have questions? Browse our FAQs page to discover everything you need to know about our vibrant community and find the perfect home for you!",
  "property_floorplans_blurb": "<p>With just a few clicks, you can take a stroll through your new home at The Pointe. Find the perfect floorplan with the amenities that sets you up for your perferred lifestyle!</p>",
  "property_gallery_blurb": "<p>Nothing helps you to imagine the possibilities for a new townhomes quite like photography. Take a look at photo collections that capture the unique and beautiful spaces in our <a href=\"/neighborhood/\">community</a> and <a href=\"/floor-plans/\">apartments.</a></p>",
  "property_interactivemap_blurb": "Discover your ideal living space at The Pointe in Beaumont, TX! Our community offers spacious one and two-bedroom floor plans, complemented by top-tier amenities like a fitness center, inviting pool, and playground. Use our interactive community map to explore available apartments and find your perfect home today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "Discover The Pointe in Beaumont, TX, where great friends make great neighbors! Explore our inviting one and two-bedroom floor plans that cater to your lifestyle. Don’t keep the experience to yourself—refer a friend to our vibrant community today and enjoy the perks of living together!",
  "property_residentaccess_blurb": "Welcome to The Pointe in Beaumont, TX! Explore our spacious one and two-bedroom floor plans, perfectly designed for your lifestyle. Current residents can easily access the resident portal to pay rent, schedule maintenance, and enjoy a seamless living experience. Log in now to stay connected with your home!",
  "property_reviews_blurb": "At The Pointe in Beaumont, TX, residents rave about our “awesome amenities” and “spacious floorplans.” Enjoy the tranquility of our neighborhood, where even the townhouse layouts surprise with a bonus loft room. Don’t just take our word for it—see what our residents have to say about living here!",
  "property_created_at": "1752257095095",
  "property_scheduletour_blurb": "Discover your ideal home at The Pointe in Beaumont, TX! Choose from our spacious one and two-bedroom floor plans, designed for modern living. Schedule a tour today and see what our residents have to say about life in our vibrant community! Your perfect apartment awaits at The Pointe!",
  "property_thankyou_blurb": "Thank you for your interest in The Pointe in Beaumont, TX! We offer spacious one and two-bedroom floor plans designed for your comfort. Explore our community and find your perfect home. A member of our team will contact you shortly to assist with your inquiries. Welcome to The Pointe!",
  "property_virtualtours_blurb": "<p>At The Pointe, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2025 All Rights Reserved. The Pointe",
  "property_seo_title_home": "The Pointe | Apartments in Beaumont, TX",
  "property_seo_description_home": "Discover luxury living at The Pointe in Beaumont, TX! Choose from spacious one or two-bedroom floor plans designed for your comfort. Enjoy top-notch amenities, including a refreshing pool, fitness center, and playground, all in a secure environment with night patrol and gated access. Experience convenience with covered parking and on-site laundry facilities. Find your new home today at The Pointe!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 2 Apartments in Beaumont, TX",
  "property_seo_description_floorplans": "Discover your ideal living space at The Pointe in Beaumont, TX! Explore our diverse floor plans, featuring stylish one and two-bedroom apartments that fit your lifestyle. Ready to call The Pointe home? Browse our available apartment homes today and find your perfect floor plan!",
  "property_seo_title_amenities": "Amenities | Beaumont, TX Apartments for Rent",
  "property_seo_description_amenities": "Discover The Pointe in Beaumont, TX! Our community offers spacious one and two-bedroom floor plans, complemented by exceptional amenities such as a refreshing pool, state-of-the-art fitness center, and secure gated access. Enjoy peace of mind with night patrol, convenience with covered parking, and fun for all ages at our playground. Explore our amazing community amenities and apartment features today!",
  "property_seo_title_gallery": "Gallery | Apartments in Beaumont, TX",
  "property_seo_description_gallery": "Explore the stunning Photo Gallery of The Pointe, your ideal apartment community in Beaumont, TX! Discover our spacious one and two-bedroom floor plans, and envision a lifestyle enriched by top-tier amenities like a fitness center, pool, playground, and covered parking. With night patrol and secure gates, your comfort and safety are our priorities. Picture yourself living here today!",
  "property_seo_title_virtualtours": "Virtual Tours | The Pointe Apartments",
  "property_seo_description_virtualtours": "Explore The Pointe in Beaumont, TX, where luxury meets comfort! Discover our thoughtfully designed one and two-bedroom floor plans that suit your lifestyle. Take a virtual tour of our vibrant community and see why The Pointe is the perfect place to call home. Don't miss out - take a virtual tour of our apartments for rent today!",
  "property_seo_title_interactivemap": "Interactive Map | The Pointe Apartments",
  "property_seo_description_interactivemap": "Discover your perfect home at The Pointe in Beaumont, TX! Explore our interactive community map to find one and two-bedroom apartments, complete with fantastic amenities like a pool, fitness center, and playground. Enjoy the peace of mind provided by our night patrol, gated access, and covered parking. Start your journey to a vibrant lifestyle—view available apartments and pricing today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Beaumont, TX",
  "property_seo_description_neighborhood": "Discover your perfect home at The Pointe in Beaumont, TX! Explore our spacious one and two-bedroom floor plans and immerse yourself in the vibrant neighborhood. See what's around our community and uncover local favorites and nearby points of interest. Start your new adventure today!",
  "property_seo_title_contact": "Contact Us | The Pointe",
  "property_seo_description_contact": "Discover your perfect home at The Pointe in Beaumont, TX! Explore our spacious one and two-bedroom floor plans designed for comfort and style. Have questions? Contact our leasing team today and let us help you find your ideal apartment!",
  "property_seo_title_faqs": "FAQs | Apartments in Beaumont, TX",
  "property_seo_description_faqs": "Discover all you need to know about The Pointe in Beaumont, TX! Our FAQs page covers everything from our diverse floor plans—one and two-bedroom options—to top-notch amenities like a fitness center, pool, playground, and night patrol. With features like gated access and covered parking, your comfort and security are paramount. Browse our FAQs page now and get the answers you need!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Beaumont, TX",
  "property_seo_description_reviews": "Discover The Pointe in Beaumont, TX—your perfect apartment community offering spacious one and two-bedroom floor plans and exceptional amenities! Enjoy peace of mind with night patrol and secure gated access, unwind by the pool, or stay active at our fitness center. Residents love our covered parking, laundry facilities, and playground. Curious about life at The Pointe? See what our residents have to say about their experience living here!",
  "property_seo_title_applynow": "Apply Now | Apartments in Beaumont, TX",
  "property_seo_description_applynow": "Discover your ideal living space at The Pointe in Beaumont, TX! Explore our spacious one and two-bedroom floor plans and enjoy exceptional amenities including a sparkling pool, fitness center, playground, covered parking, laundry facilities, and 24-hour night patrol for peace of mind. Ready to make The Pointe your new home? Apply now and lease online today! Your perfect apartment awaits!",
  "property_seo_title_residentaccess": "Resident Access | The Pointe",
  "property_seo_description_residentaccess": "\"Welcome to The Pointe in Beaumont, TX! Access your resident portal to easily pay rent, schedule maintenance, and manage your apartment needs all in one place. Enjoy a seamless living experience today!\"",
  "property_seo_title_referafriend": "Refer A Friend | The Pointe",
  "property_seo_description_referafriend": "\"Unlock a great living experience at The Pointe in Beaumont, TX! Refer a friend today and enjoy the benefits of great neighbors and a vibrant community. Your perfect apartment awaits!\"",
  "property_seo_title_scheduletour": "Schedule a Tour | The Pointe",
  "property_seo_description_scheduletour": "Discover your new home at The Pointe in Beaumont, TX! Schedule a tour today and explore our stunning apartments, premium amenities, and vibrant community. Don’t miss your chance to find the perfect place to call home—book your visit now!",
  "property_seo_title_privacy": "Privacy Policy | The Pointe",
  "property_seo_description_privacy": "\"Discover how The Pointe in Beaumont, TX safeguards your personal information. Our Privacy Policy outlines our commitment to transparency and security. View our privacy policy to learn more!\"",
  "property_seo_title_accessibility": "Website Accessibility | The Pointe",
  "property_seo_description_accessibility": "\"Discover The Pointe in Beaumont, TX, where we prioritize digital inclusion and accessibility for all residents. Learn about our commitment to creating an inclusive community and how we ensure every visitor can experience our vibrant apartment living. Join us today and explore a home designed for everyone!\"",
  "property_seo_title_sitemap": "Sitemap | The Pointe",
  "property_seo_description_sitemap": "\"Discover The Pointe in Beaumont, TX! Explore our sitemap to easily navigate through our luxurious apartment offerings, amenities, and community features. View our website sitemap now to find your perfect home!\"",
  "property_seo_title_thankyou": "Thank You | The Pointe",
  "property_seo_description_thankyou": "\"Thank you for your interest in The Pointe, Beaumont's premier apartment community! We appreciate your submission and a team member will reach out to you shortly. Discover the exceptional lifestyle and vibrant community that awaits you!\"",
  "property_seo_title_pets": "Pet Policy | Apartments in Beaumont, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293615409",
  "amenities": [
    {
      "id": "ec_dbb46e8bd5a8ea9a550d7a03",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Shimmering Swimming Pool with Outdoor Lounge and Grilling Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d63df048f23ca5a3dd4687d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_069e124d181ff9b52758c331",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Bark Park with Agility Course",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_41d4f42186164851ef246794",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3c1cb91dcd788baece5a792c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Picnic Area with Barbecue",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_55349fa76c18a227aaaa6c98",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse with Business Center and Free WIFI",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2264e88024b1886dd52aaaae",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Coffee and Tea Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1754964b873c234ff4b063bc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Assigned Resident Parking with Available Guest Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8c2c2556e01989157435b380",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Pet-Friendly",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0cf8809eedc5e175b40f7823",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cbe8c0c44266de80ca4ea2da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Lush Greenery and Beautiful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_804e627276fd9c524839c94a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Neighborhood‑Feel Community Layout",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a97d5422212776a1a2252fbe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Conveniently Located Near Shopping and Restaurants",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bec547277dbde97cf90340fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Corporate Housing Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e7c8b2e93646e01013ddc8c4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "24‑Hour Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c71bf11e5754c0c52b5620cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7aa8ca4b9bebd2bd0327a33d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Flexible Rent Payment Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_34ba6b28e8c3c33530fc4f14",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a647600235c8b92faea1caf8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Professional On‑site Maintenance with 24‑Hour Emergency Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f377d7e0a6ca27be8f7c172",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f0e8db4aac7dc03fb9f71094",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Flexible Leasing Terms",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_17cb6746ff9272f65803eb78",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Spacious, Open‑Concept Floorplans with Extra‑Large Square Footage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2fa91711e5698db7248a1666",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Luxury Wood‑Designed and Carpeted Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f15ee71b509416a2e30635b0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Private Walk‑In Entrances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c831a2338fb5d5229e9b8dd6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Private Master Patios and Balconies*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_585ea73e5782558eb60f9dad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Energy‑Efficient, Modern Black Appliances",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5355f905d1a1075e4d49bd2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Chef‑Ready Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6e897c49b077bb360f0a3ab5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Custom‑Feel Hardwood Cabinetry with Select Upgrades",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b10b8f3d2272f8cfbd33247f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Full‑Sized Washer and Dryer",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b90b156f75de9e14aebdc4a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Garden‑Style Tubs",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_454f7a2907a15d71cacdfc6e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Renovated Homes*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8875cb98bd4899655372312e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Vaulted Ceilings*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2c208266406f628b9054eea9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Loft*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c68f1820ed8c5c8ca95b4aa3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Skylights*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1a3ca7fe6b3d4e26bd6adcd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Ceiling Fans",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6d24016cc3246e6f9b36a538",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "2\" Faux Wood Blinds",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_689c538663314baabb35178a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Expansive Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f3e1c89d4598f96b9c252ad9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Modern LED Lighting*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0bf708748fb51588a10f1d10",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "High-Speed Internet Access and Cable Ready",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d56519f4763d41707a162117",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_3a560186-46b8-4062-9862-f75c70267140",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/01a09187-0a5e-7391-a88e-45c96dde5b7d.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a playground in the background.",
        "public_id": "01a09187-0a5e-7391-a88e-45c96dde5b7d",
        "storage_key": "property/6737460151191771/01a09187-0a5e-7391-a88e-45c96dde5b7d.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling swimming pool, surrounded by lush greenery and comfortable lounge seating. Perfect for a sunny afternoon getaway.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and a playground in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5dd4da95-f1b9-4a2b-87d3-484fa2e952fd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/01a09187-0fd0-70c8-8f14-e448f25a3659.webp",
      "image_media": {
        "alt_text": "Cozy living room with a TV, sofa, armchair, coffee table, and a bar area.",
        "public_id": "01a09187-0fd0-70c8-8f14-e448f25a3659",
        "storage_key": "property/6737460151191771/01a09187-0fd0-70c8-8f14-e448f25a3659.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Relax in this inviting living space featuring a mounted TV, plush seating, and a convenient breakfast bar. Perfect for entertaining or quiet evenings.",
      "link": "",
      "alt_text": "Cozy living room with a TV, sofa, armchair, coffee table, and a bar area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2c03bc2e-b257-4248-8491-6bf3fd55bee8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/01a09187-0b84-76e1-af9b-9d4195e41c02.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, four chairs, and a bay window with blinds.",
        "public_id": "01a09187-0b84-76e1-af9b-9d4195e41c02",
        "storage_key": "property/6737460151191771/01a09187-0b84-76e1-af9b-9d4195e41c02.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Cozy dining area with a round wooden table and upholstered chairs, featuring a bay window that fills the space with natural light.",
      "link": "",
      "alt_text": "Dining area with a round table, four chairs, and a bay window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1eff4bfa-e664-4d9a-925a-dfeed1cdd284",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/01a09187-0934-754e-be58-68f586e7ec29.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, walk-in closet, dresser, and ceiling fan.",
        "public_id": "01a09187-0934-754e-be58-68f586e7ec29",
        "storage_key": "property/6737460151191771/01a09187-0934-754e-be58-68f586e7ec29.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a king-size bed, a walk-in closet, and a dresser, perfect for comfortable living.",
      "link": "",
      "alt_text": "Bedroom with a king-size bed, walk-in closet, dresser, and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_507e1e5e-2d5c-4c8d-af1e-b3125994e0b7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/01a09187-0935-74aa-9cbc-27ffdaa5cebc.webp",
      "image_media": {
        "alt_text": "Kitchen with black appliances and oak cabinets",
        "public_id": "01a09187-0935-74aa-9cbc-27ffdaa5cebc",
        "storage_key": "property/6737460151191771/01a09187-0935-74aa-9cbc-27ffdaa5cebc.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Apartment",
      "description": "A functional kitchen space featuring black appliances, double sink, and ample oak cabinetry, perfect for meal preparation.",
      "link": "",
      "alt_text": "Kitchen with black appliances and oak cabinets",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d5ce3aee-9086-4b5a-b287-e4a4c9846221",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/01a09187-10a5-751b-9e90-e6f40f9151c0.webp",
      "image_media": {
        "alt_text": "Interior of a community lounge with a kitchen, seating areas, and a view of the pool.",
        "public_id": "01a09187-10a5-751b-9e90-e6f40f9151c0",
        "storage_key": "property/6737460151191771/01a09187-10a5-751b-9e90-e6f40f9151c0.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed community lounge, featuring a full kitchen, comfortable seating, and scenic views of the sparkling pool.",
      "link": "",
      "alt_text": "Interior of a community lounge with a kitchen, seating areas, and a view of the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14a93e67-c6dd-40f3-882a-5d7bd06f48b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/01a09187-098e-723c-a57c-78c18493c6bd.webp",
      "image_media": {
        "alt_text": "Lobby area with a reception desk, seating area, and kitchen.",
        "public_id": "01a09187-098e-723c-a57c-78c18493c6bd",
        "storage_key": "property/6737460151191771/01a09187-098e-723c-a57c-78c18493c6bd.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Welcome to our spacious and modern lobby, featuring a comfortable seating area, a full kitchen, and a reception desk. Enjoy the convenience and style of our community amenities.",
      "link": "",
      "alt_text": "Lobby area with a reception desk, seating area, and kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_18d0c8f8-6045-4b5b-bf36-fb915d257f78",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/01a09187-1049-74a3-b809-63338ea0d5ec.webp",
      "image_media": {
        "alt_text": "Two stationary bikes in a room with blinds and cubbies.",
        "public_id": "01a09187-1049-74a3-b809-63338ea0d5ec",
        "storage_key": "property/6737460151191771/01a09187-1049-74a3-b809-63338ea0d5ec.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Equipped fitness center with stationary bikes, perfect for a morning workout.",
      "link": "",
      "alt_text": "Two stationary bikes in a room with blinds and cubbies.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_147f13f9-8a85-4cb8-9ce9-eadb0ba9ae60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/01a09187-0ff3-731c-a8ed-9d386be95b3d.webp",
      "image_media": {
        "alt_text": "Gym with treadmills, elliptical, and recumbent bike",
        "public_id": "01a09187-0ff3-731c-a8ed-9d386be95b3d",
        "storage_key": "property/6737460151191771/01a09187-0ff3-731c-a8ed-9d386be95b3d.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Community",
      "description": "Stay active in our well-equipped fitness center, featuring treadmills, an elliptical, and a recumbent bike.",
      "link": "",
      "alt_text": "Gym with treadmills, elliptical, and recumbent bike",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_31909635-436d-4fa2-91f6-c4c944b2ad98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-708a-7654-aaf0-05ca9d7832d8.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with blue lounge chairs and palm trees",
        "public_id": "019e84cb-708a-7654-aaf0-05ca9d7832d8",
        "storage_key": "property/6737460151191771/019e84cb-708a-7654-aaf0-05ca9d7832d8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, surrounded by lush palm trees and comfortable lounge chairs. A perfect oasis for soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool with blue lounge chairs and palm trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4d0d1ec4-08c2-4459-b16c-96418e72da7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-7307-728b-a07d-4740d5eef64e.webp",
      "image_media": {
        "alt_text": "Exterior of brick apartment buildings with balconies and manicured lawns under a clear blue sky.",
        "public_id": "019e84cb-7307-728b-a07d-4740d5eef64e",
        "storage_key": "property/6737460151191771/019e84cb-7307-728b-a07d-4740d5eef64e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautiful brick apartment buildings with private balconies and lush green lawns, offering a comfortable and inviting living environment.",
      "link": "",
      "alt_text": "Exterior of brick apartment buildings with balconies and manicured lawns under a clear blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6c590627-b788-4a03-a40f-da8623444ce5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-6cec-7468-b57d-fbdb0392a7ea.webp",
      "image_media": {
        "alt_text": "Treadmills and elliptical machines in a fitness center with orange and gray walls.",
        "public_id": "019e84cc-6cec-7468-b57d-fbdb0392a7ea",
        "storage_key": "property/6737460151191771/019e84cc-6cec-7468-b57d-fbdb0392a7ea.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring treadmills and elliptical machines for your workout needs.",
      "link": "",
      "alt_text": "Treadmills and elliptical machines in a fitness center with orange and gray walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa1da915-d1df-4628-ab42-4f9b325a9149",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-68b5-7693-9f74-5ddde0ee20ec.webp",
      "image_media": {
        "alt_text": "Gym with weight machines, treadmills, and ellipticals.",
        "public_id": "019e84cc-68b5-7693-9f74-5ddde0ee20ec",
        "storage_key": "property/6737460151191771/019e84cc-68b5-7693-9f74-5ddde0ee20ec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring cardio machines and strength-training equipment.",
      "link": "",
      "alt_text": "Gym with weight machines, treadmills, and ellipticals.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_30f8648c-7813-43c4-b758-99248edb9eb8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-69ec-712a-a6fc-53dd09b88671.webp",
      "image_media": {
        "alt_text": "Gym with dumbbells, weight machines, exercise balls, and a weight bench.",
        "public_id": "019e84cc-69ec-712a-a6fc-53dd09b88671",
        "storage_key": "property/6737460151191771/019e84cc-69ec-712a-a6fc-53dd09b88671.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully equipped fitness center, featuring a variety of weight machines, free weights, and cardio equipment for a complete workout.",
      "link": "",
      "alt_text": "Gym with dumbbells, weight machines, exercise balls, and a weight bench.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c3985f4d-c78d-471c-a288-78f544b77aac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-2b08-73be-8747-cd7c5b38c6f6.webp",
      "image_media": {
        "alt_text": "Dog park with agility equipment, tunnel, and benches.",
        "public_id": "019e84cb-2b08-73be-8747-cd7c5b38c6f6",
        "storage_key": "property/6737460151191771/019e84cb-2b08-73be-8747-cd7c5b38c6f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with agility equipment and ample space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "Dog park with agility equipment, tunnel, and benches.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_29bd8c41-905d-4de4-9ee6-880dce5c18ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-66f7-734b-b2ad-47d39a5cd090.webp",
      "image_media": {
        "alt_text": "Fenced dog park with agility equipment, playground, and seating areas.",
        "public_id": "019e84cc-66f7-734b-b2ad-47d39a5cd090",
        "storage_key": "property/6737460151191771/019e84cc-66f7-734b-b2ad-47d39a5cd090.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious and fenced dog park, complete with agility equipment and a separate playground area for children. A perfect spot for pets and families to play.",
      "link": "",
      "alt_text": "Fenced dog park with agility equipment, playground, and seating areas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_79c61c11-e6b9-41a2-b6bd-03610033f6cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-60bd-7309-8ab3-29a22923944c.webp",
      "image_media": {
        "alt_text": "Kitchen and living area with carpeted floors, stairs, and large window.",
        "public_id": "019e84cc-60bd-7309-8ab3-29a22923944c",
        "storage_key": "property/6737460151191771/019e84cc-60bd-7309-8ab3-29a22923944c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area and kitchen with carpeted floors, stairs, and a large window. Ideal for comfortable living.",
      "link": "",
      "alt_text": "Kitchen and living area with carpeted floors, stairs, and large window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2aa77bc0-99fe-49d4-ae2e-ecf5e5624a2c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-6353-72b9-8bf9-bf6da4671777.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a playground.",
        "public_id": "019e84cc-6353-72b9-8bf9-bf6da4671777",
        "storage_key": "property/6737460151191771/019e84cc-6353-72b9-8bf9-bf6da4671777.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and an adjacent playground for family fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d7ee10db-951f-4de9-9d18-932aca8daddc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-6263-7250-8ff9-2beb421e73cb.webp",
      "image_media": {
        "alt_text": "Open-concept living area and kitchen with a ceiling fan, vaulted ceiling, and stairs.",
        "public_id": "019e84cc-6263-7250-8ff9-2beb421e73cb",
        "storage_key": "property/6737460151191771/019e84cc-6263-7250-8ff9-2beb421e73cb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with a vaulted ceiling, ceiling fan, and an open-concept kitchen. Perfect for entertaining and comfortable living.",
      "link": "",
      "alt_text": "Open-concept living area and kitchen with a ceiling fan, vaulted ceiling, and stairs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_813069ab-907b-4fa5-89e2-82a05580d33c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-623a-72c9-93e4-6ef2a3e5b0db.webp",
      "image_media": {
        "alt_text": "Kitchen with oak cabinets, black appliances, and light wood laminate flooring.",
        "public_id": "019e84cc-623a-72c9-93e4-6ef2a3e5b0db",
        "storage_key": "property/6737460151191771/019e84cc-623a-72c9-93e4-6ef2a3e5b0db.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and functional kitchen featuring ample oak cabinetry, a double sink, black dishwasher, stove, and refrigerator. Light wood laminate flooring completes the look.",
      "link": "",
      "alt_text": "Kitchen with oak cabinets, black appliances, and light wood laminate flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d89758c6-4dcc-4d78-bc20-3badfa4b6743",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-5222-77a8-b54c-c5ff364c3319.webp",
      "image_media": {
        "alt_text": "Interior view of a loft bedroom with a ceiling fan and an open doorway.",
        "public_id": "019e84cc-5222-77a8-b54c-c5ff364c3319",
        "storage_key": "property/6737460151191771/019e84cc-5222-77a8-b54c-c5ff364c3319.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious loft bedroom with plush carpeting and a modern ceiling fan. Features an open doorway leading to another room, offering a sense of openness and light.",
      "link": "",
      "alt_text": "Interior view of a loft bedroom with a ceiling fan and an open doorway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_95a4caf0-5c73-470c-b779-67dacaf37ba0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-5372-70dc-85f4-4d110c0c1dad.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and doorway to bathroom.",
        "public_id": "019e84cc-5372-70dc-85f4-4d110c0c1dad",
        "storage_key": "property/6737460151191771/019e84cc-5372-70dc-85f4-4d110c0c1dad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and plush carpeting, with an adjacent bathroom visible through the doorway.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and doorway to bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a4f906c6-cb49-4eca-8a7b-a325512cb3a5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-50ad-733d-a8fe-33049dcb3196.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and doorway to bathroom.",
        "public_id": "019e84cc-50ad-733d-a8fe-33049dcb3196",
        "storage_key": "property/6737460151191771/019e84cc-50ad-733d-a8fe-33049dcb3196.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and neutral gray carpeting. A doorway reveals an adjacent bathroom with a vanity and toilet.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and doorway to bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b48526b9-9968-4a3d-97ed-fb9a44450fce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-4bad-7527-9384-9eaefa7a4316.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and door.",
        "public_id": "019e84cc-4bad-7527-9384-9eaefa7a4316",
        "storage_key": "property/6737460151191771/019e84cc-4bad-7527-9384-9eaefa7a4316.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a wooden vanity with a countertop, a sink, and a mirror above. A toilet and a door are also visible.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8c50de94-4142-4236-a16b-3a58ac5afb19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-75fe-73f9-adf3-7fb9b59908a8.webp",
      "image_media": {
        "alt_text": "Exterior view of brick apartment buildings with green grass and a walkway.",
        "public_id": "019e84cb-75fe-73f9-adf3-7fb9b59908a8",
        "storage_key": "property/6737460151191771/019e84cb-75fe-73f9-adf3-7fb9b59908a8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Exterior view of brick apartment buildings with well-maintained green grass and a concrete walkway leading to the entrances.",
      "link": "",
      "alt_text": "Exterior view of brick apartment buildings with green grass and a walkway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2ba04b6-9ac8-4c96-94a9-fc144812d85c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-4de1-722b-8432-1b6a4183b87e.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan and doors leading to another room and a bathroom.",
        "public_id": "019e84cc-4de1-722b-8432-1b6a4183b87e",
        "storage_key": "property/6737460151191771/019e84cc-4de1-722b-8432-1b6a4183b87e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, plush carpeting, and access to an additional room and a bathroom, perfect for comfortable living.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan and doors leading to another room and a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c345b760-8719-4e2a-b6e4-b96ee2592cc6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-4c59-714f-bf19-e1e7bbf55e80.webp",
      "image_media": {
        "alt_text": "Empty bedroom with vaulted ceiling and ceiling fan.",
        "public_id": "019e84cc-4c59-714f-bf19-e1e7bbf55e80",
        "storage_key": "property/6737460151191771/019e84cc-4c59-714f-bf19-e1e7bbf55e80.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a vaulted ceiling, ceiling fan, and large window.",
      "link": "",
      "alt_text": "Empty bedroom with vaulted ceiling and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ed18e71c-73f9-468e-8184-51f1e00b2df5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-2043-775f-9bf3-db091e505dd8.webp",
      "image_media": {
        "alt_text": "Aerial view of a swimming pool and playground at a multifamily property.",
        "public_id": "019e84cc-2043-775f-9bf3-db091e505dd8",
        "storage_key": "property/6737460151191771/019e84cc-2043-775f-9bf3-db091e505dd8.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy resort-style living with our sparkling swimming pool and fun-filled playground, perfect for relaxation and recreation.",
      "link": "",
      "alt_text": "Aerial view of a swimming pool and playground at a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2b8d3153-0f80-4bc1-bd7c-13cc912bff8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cc-17cb-72f9-8557-139f9feb8b6b.webp",
      "image_media": {
        "alt_text": "Aerial view of the apartment complex's pool and playground amenities.",
        "public_id": "019e84cc-17cb-72f9-8557-139f9feb8b6b",
        "storage_key": "property/6737460151191771/019e84cc-17cb-72f9-8557-139f9feb8b6b.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling pool or let the kids play at the vibrant playground. Outdoor living at its finest!",
      "link": "",
      "alt_text": "Aerial view of the apartment complex's pool and playground amenities.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ddd9466a-0023-40c5-bbb1-f6770a116683",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-eeaf-7504-83e5-c34357f22575.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property's entrance and grounds, showcasing buildings, landscaping, and a playground.",
        "public_id": "019e84cb-eeaf-7504-83e5-c34357f22575",
        "storage_key": "property/6737460151191771/019e84cb-eeaf-7504-83e5-c34357f22575.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "An aerial view captures the welcoming entrance of this multifamily property, highlighting the lush landscaping, various building exteriors, and a dedicated children's playground, creating an inviting community atmosphere.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property's entrance and grounds, showcasing buildings, landscaping, and a playground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_828f0e92-74d1-4cd3-92f1-15b0420f6ab5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-cb22-73fb-accc-ab1aa5543f19.webp",
      "image_media": {
        "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and a picnic area with a grill.",
        "public_id": "019e84cb-cb22-73fb-accc-ab1aa5543f19",
        "storage_key": "property/6737460151191771/019e84cb-cb22-73fb-accc-ab1aa5543f19.webp",
        "width": 3072,
        "height": 2304
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling outdoor swimming pool, perfect for relaxing on a sunny day. Featuring ample lounge chairs and a shaded picnic area with a grill for al fresco dining.",
      "link": "",
      "alt_text": "Aerial view of an outdoor swimming pool with lounge chairs and a picnic area with a grill.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3c0651a6-ef53-4b0e-a8a5-8cd33bb6335f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-a6d8-7059-a139-307a21e13a19.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and view into bathroom",
        "public_id": "019e84cb-a6d8-7059-a139-307a21e13a19",
        "storage_key": "property/6737460151191771/019e84cb-a6d8-7059-a139-307a21e13a19.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, plush carpeting, and a view into the en-suite bathroom with a toilet and shower.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and view into bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f0e897c-f4ea-4e86-9a87-c7cdcb2273bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-a083-724f-a8b1-58b9121b4ec3.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and doorway to bathroom",
        "public_id": "019e84cb-a083-724f-a8b1-58b9121b4ec3",
        "storage_key": "property/6737460151191771/019e84cb-a083-724f-a8b1-58b9121b4ec3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring plush carpeting and a ceiling fan. A view into the adjacent bathroom with a vanity and tub is visible through the doorway.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and doorway to bathroom",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1cae85ed-db0f-4604-8a07-717035e0a99e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-a382-76dc-977e-00b4ba9984b2.webp",
      "image_media": {
        "alt_text": "Kitchen and living room area with stairs",
        "public_id": "019e84cb-a382-76dc-977e-00b4ba9984b2",
        "storage_key": "property/6737460151191771/019e84cb-a382-76dc-977e-00b4ba9984b2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Open concept living space featuring a modern kitchen and a spacious living area with carpet and a ceiling fan.",
      "link": "",
      "alt_text": "Kitchen and living room area with stairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_21a2e9f8-f4db-4277-abcd-668480f260eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-a3eb-7145-ba16-31237182df68.webp",
      "image_media": {
        "alt_text": "Balcony view overlooking apartment buildings and parking lot with palm trees.",
        "public_id": "019e84cb-a3eb-7145-ba16-31237182df68",
        "storage_key": "property/6737460151191771/019e84cb-a3eb-7145-ba16-31237182df68.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the outdoors from your private balcony with scenic views of the community grounds and convenient parking.",
      "link": "",
      "alt_text": "Balcony view overlooking apartment buildings and parking lot with palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4cda6ada-aa3f-4a53-8ba4-79a1e573d4e6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-9b2c-73b0-ac64-fc0b8a003775.webp",
      "image_media": {
        "alt_text": "Empty bedroom with vaulted ceiling and ceiling fan.",
        "public_id": "019e84cb-9b2c-73b0-ac64-fc0b8a003775",
        "storage_key": "property/6737460151191771/019e84cb-9b2c-73b0-ac64-fc0b8a003775.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a vaulted ceiling, a ceiling fan, and a large window. This room offers a blank canvas for your personal style.",
      "link": "",
      "alt_text": "Empty bedroom with vaulted ceiling and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8454460e-d547-4331-b93f-314793dc8d56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-9e55-777f-8054-d46940f38e57.webp",
      "image_media": {
        "alt_text": "Interior view of a room with carpet and a ceiling fan.",
        "public_id": "019e84cb-9e55-777f-8054-d46940f38e57",
        "storage_key": "property/6737460151191771/019e84cb-9e55-777f-8054-d46940f38e57.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious room with plush carpeting and a ceiling fan, featuring a pass-through to another area of the apartment.",
      "link": "",
      "alt_text": "Interior view of a room with carpet and a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ab006ac3-b779-41e6-bdcb-f3fb055e66eb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-9d0c-703d-8381-2a59918e9662.webp",
      "image_media": {
        "alt_text": "Kitchen with oak cabinets, stainless steel sink, dishwasher, and black stove.",
        "public_id": "019e84cb-9d0c-703d-8381-2a59918e9662",
        "storage_key": "property/6737460151191771/019e84cb-9d0c-703d-8381-2a59918e9662.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-lit kitchen featuring ample storage with oak cabinets, a double basin sink, a dishwasher, and a black electric stove. The countertops have a speckled pattern, complementing the wood-look flooring.",
      "link": "",
      "alt_text": "Kitchen with oak cabinets, stainless steel sink, dishwasher, and black stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1cf6382d-a727-41e0-a1aa-9ba2f5067ec7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-9749-7109-8f30-9e9aa8d3b648.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink, toilet, and towel rack.",
        "public_id": "019e84cb-9749-7109-8f30-9e9aa8d3b648",
        "storage_key": "property/6737460151191771/019e84cb-9749-7109-8f30-9e9aa8d3b648.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a wood vanity with a granite-look countertop, a white sink and toilet, and a mirror with vanity lighting.",
      "link": "",
      "alt_text": "Bathroom vanity with sink, toilet, and towel rack.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_8ac48aa0-f6e2-4c55-b7b8-07e985f66b39",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-a0a2-76ec-a4c0-9a5933370d88.webp",
      "image_media": {
        "alt_text": "Living area and kitchen with wood cabinets and black appliances.",
        "public_id": "019e84cb-a0a2-76ec-a4c0-9a5933370d88",
        "storage_key": "property/6737460151191771/019e84cb-a0a2-76ec-a4c0-9a5933370d88.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting, leading into a well-equipped kitchen featuring wood cabinetry and black appliances. Perfect for modern living.",
      "link": "",
      "alt_text": "Living area and kitchen with wood cabinets and black appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f881d7d-ab25-4bce-8d7b-ecb4e1013b65",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-9865-72ff-b0fb-e98a202c12c8.webp",
      "image_media": {
        "alt_text": "Bedroom with ceiling fan and view into an en-suite bathroom with vanity and toilet.",
        "public_id": "019e84cb-9865-72ff-b0fb-e98a202c12c8",
        "storage_key": "property/6737460151191771/019e84cb-9865-72ff-b0fb-e98a202c12c8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan and plush carpeting. An en-suite bathroom is accessible through the doorway, offering a vanity and toilet for convenience.",
      "link": "",
      "alt_text": "Bedroom with ceiling fan and view into an en-suite bathroom with vanity and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fe458d51-e670-45ba-a9d6-bfa571ef216d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-75e9-75e8-aa36-9eedaab6ddce.webp",
      "image_media": {
        "alt_text": "Exterior of a two-story apartment building with brick and white siding, surrounded by trees and grass.",
        "public_id": "019e84cb-75e9-75e8-aa36-9eedaab6ddce",
        "storage_key": "property/6737460151191771/019e84cb-75e9-75e8-aa36-9eedaab6ddce.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of the exterior of an apartment building, showcasing its architecture and landscaping. This building includes multiple units and common outdoor areas.",
      "link": "",
      "alt_text": "Exterior of a two-story apartment building with brick and white siding, surrounded by trees and grass.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_32200db8-5e3c-4fd2-8719-2794729b1c87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-77e0-7739-9f7c-edc31d7776a0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a brick building in the background.",
        "public_id": "019e84cb-77e0-7739-9f7c-edc31d7776a0",
        "storage_key": "property/6737460151191771/019e84cb-77e0-7739-9f7c-edc31d7776a0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind by our stunning resort-style swimming pool. Enjoy the sun on comfortable lounge chairs and soak up the vibrant atmosphere of our community.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a brick building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b2761d4c-8dc8-48a6-8350-c00ea9d15880",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-78cd-7700-9dd1-80d825333a63.webp",
      "image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019e84cb-78cd-7700-9dd1-80d825333a63",
        "storage_key": "property/6737460151191771/019e84cb-78cd-7700-9dd1-80d825333a63.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor fun at our community playground, featuring exciting slides and climbing structures for children.",
      "link": "",
      "alt_text": "Playground with slides and climbing structures.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_71c584f1-6fbf-40c7-be28-f98626bfcf7c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-727a-700b-827a-b5c4cc9e10de.webp",
      "image_media": {
        "alt_text": "A clean and functional bathroom featuring a sink, toilet, and shower.",
        "public_id": "019e84cb-727a-700b-827a-b5c4cc9e10de",
        "storage_key": "property/6737460151191771/019e84cb-727a-700b-827a-b5c4cc9e10de.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom offers a practical layout with a vanity, toilet, and shower, perfect for daily routines.",
      "link": "",
      "alt_text": "A clean and functional bathroom featuring a sink, toilet, and shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b621b3b7-fb1d-41a5-a126-ad11c0ad9ece",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-710e-77ab-a14d-c596eaadff78.webp",
      "image_media": {
        "alt_text": "Washer and dryer appliances with shelves above.",
        "public_id": "019e84cb-710e-77ab-a14d-c596eaadff78",
        "storage_key": "property/6737460151191771/019e84cb-710e-77ab-a14d-c596eaadff78.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit washer and dryer with overhead shelving for storage.",
      "link": "",
      "alt_text": "Washer and dryer appliances with shelves above.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1aab829-a798-40f8-8a3e-5085dd2272d0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-78ca-709b-b2e6-80d1a2609e10.webp",
      "image_media": {
        "alt_text": "Living room with vaulted ceiling, ceiling fan, and view into kitchen and hallway.",
        "public_id": "019e84cb-78ca-709b-b2e6-80d1a2609e10",
        "storage_key": "property/6737460151191771/019e84cb-78ca-709b-b2e6-80d1a2609e10.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a vaulted ceiling, ceiling fan, and plush carpeting. Enjoy an open view into the adjacent kitchen and hallway area.",
      "link": "",
      "alt_text": "Living room with vaulted ceiling, ceiling fan, and view into kitchen and hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4c3453c1-34e0-4c8d-b060-2f3d6c70f60c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-4ea3-77b8-9d70-faad583cf8a5.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily property with brick and siding buildings, fenced courtyard, and lush green lawn.",
        "public_id": "019e84cb-4ea3-77b8-9d70-faad583cf8a5",
        "storage_key": "property/6737460151191771/019e84cb-4ea3-77b8-9d70-faad583cf8a5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautiful exterior of the multifamily property featuring classic brick architecture, private balconies, and well-maintained grounds with a large grassy area.",
      "link": "",
      "alt_text": "Exterior of a multifamily property with brick and siding buildings, fenced courtyard, and lush green lawn.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_fa5e8a7c-a6eb-4236-ac9b-32dca009454e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-4bfe-7405-bfc4-84b0cc1f4f38.webp",
      "image_media": {
        "alt_text": "Resort-style pool with blue lounge chairs and palm trees",
        "public_id": "019e84cb-4bfe-7405-bfc4-84b0cc1f4f38",
        "storage_key": "property/6737460151191771/019e84cb-4bfe-7405-bfc4-84b0cc1f4f38.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling blue pool, surrounded by comfortable lounge chairs and lush palm trees. The perfect spot to relax and unwind.",
      "link": "",
      "alt_text": "Resort-style pool with blue lounge chairs and palm trees",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9b26752b-a761-455d-8ebc-073b2a615c40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-5213-70de-808b-1078ea5cce8f.webp",
      "image_media": {
        "alt_text": "Empty bedroom with a ceiling fan and a window.",
        "public_id": "019e84cb-5213-70de-808b-1078ea5cce8f",
        "storage_key": "property/6737460151191771/019e84cb-5213-70de-808b-1078ea5cce8f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting, a ceiling fan, and large windows for natural light.",
      "link": "",
      "alt_text": "Empty bedroom with a ceiling fan and a window.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_795f0938-b9a4-41ea-92e3-997315b30a31",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-5171-7461-a432-138335fff5d9.webp",
      "image_media": {
        "alt_text": "Exterior of apartment building with blue door and number 48.",
        "public_id": "019e84cb-5171-7461-a432-138335fff5d9",
        "storage_key": "property/6737460151191771/019e84cb-5171-7461-a432-138335fff5d9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming exterior of an apartment building with a welcoming blue door and neatly manicured lawn.",
      "link": "",
      "alt_text": "Exterior of apartment building with blue door and number 48.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_aa4ffc03-256b-4c2f-a87d-41c96a6ac9cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-5257-702d-8bc3-be48d0083d4e.webp",
      "image_media": {
        "alt_text": "Exterior view of a brick and vinyl townhouse with blue doors and a paved walkway leading to the entrance.",
        "public_id": "019e84cb-5257-702d-8bc3-be48d0083d4e",
        "storage_key": "property/6737460151191771/019e84cb-5257-702d-8bc3-be48d0083d4e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming townhome exterior with a private fenced patio and lush green lawn.",
      "link": "",
      "alt_text": "Exterior view of a brick and vinyl townhouse with blue doors and a paved walkway leading to the entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2f32b802-b784-45af-9f2b-084a788507cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-5175-72f8-8d0e-14cb1adb49d0.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with wicker furniture and bright green cushions under a wooden pergola.",
        "public_id": "019e84cb-5175-72f8-8d0e-14cb1adb49d0",
        "storage_key": "property/6737460151191771/019e84cb-5175-72f8-8d0e-14cb1adb49d0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and unwind in our comfortable outdoor seating area, perfect for enjoying the fresh air and sunshine under the shade of the pergola.",
      "link": "",
      "alt_text": "Outdoor seating area with wicker furniture and bright green cushions under a wooden pergola.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ef422f1-c96e-4679-a06c-559e83a4989c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-4494-7196-aa55-99a0da1c08b4.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily property with a blue front door and a double garage.",
        "public_id": "019e84cb-4494-7196-aa55-99a0da1c08b4",
        "storage_key": "property/6737460151191771/019e84cb-4494-7196-aa55-99a0da1c08b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View the exterior of this multifamily property featuring a welcoming blue front door and a spacious double garage, complemented by lush palm trees and manicured landscaping.",
      "link": "",
      "alt_text": "Exterior of a multifamily property with a blue front door and a double garage.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_77140a61-2bda-4aa2-90cf-39f1b4714fcc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-51a1-732b-b2b9-ee09c5fba6f3.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
        "public_id": "019e84cb-51a1-732b-b2b9-ee09c5fba6f3",
        "storage_key": "property/6737460151191771/019e84cb-51a1-732b-b2b9-ee09c5fba6f3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling blue pool, surrounded by comfortable lounge chairs and lush palm trees. Perfect for relaxation and fun.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_544e45fb-c763-4f99-9e2b-8bc267d54bd4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-4f18-74b6-9897-8a91893c728a.webp",
      "image_media": {
        "alt_text": "Exterior of a townhouse with a two-car garage and blue front door, surrounded by palm trees and lush greenery.",
        "public_id": "019e84cb-4f18-74b6-9897-8a91893c728a",
        "storage_key": "property/6737460151191771/019e84cb-4f18-74b6-9897-8a91893c728a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming townhouse exterior featuring a spacious two-car garage, a welcoming blue front door, and a balcony, all set amidst a tropical landscape with palm trees and manicured lawns.",
      "link": "",
      "alt_text": "Exterior of a townhouse with a two-car garage and blue front door, surrounded by palm trees and lush greenery.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_975d60fb-81d0-49f8-99f3-f9f60d92c96d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-294d-76a5-9e61-7a53ee431fec.webp",
      "image_media": {
        "alt_text": "Empty room with large arched window and ceiling fan.",
        "public_id": "019e84cb-294d-76a5-9e61-7a53ee431fec",
        "storage_key": "property/6737460151191771/019e84cb-294d-76a5-9e61-7a53ee431fec.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious room with plush carpeting, vaulted ceilings, and a large arched window allowing natural light to fill the space. Perfect for a bedroom or living area.",
      "link": "",
      "alt_text": "Empty room with large arched window and ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_18957aac-333d-4617-b87a-da180369f9a3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-27b2-7638-a695-2b3f28bf65b4.webp",
      "image_media": {
        "alt_text": "The Pointe Apartment Homes monument sign",
        "public_id": "019e84cb-27b2-7638-a695-2b3f28bf65b4",
        "storage_key": "property/6737460151191771/019e84cb-27b2-7638-a695-2b3f28bf65b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to The Pointe Apartment Homes, featuring beautiful grounds and welcoming interiors.",
      "link": "",
      "alt_text": "The Pointe Apartment Homes monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6173b29b-17e2-4c50-805d-b197e54feb6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-29c3-76ca-a13c-ec894ae411b4.webp",
      "image_media": {
        "alt_text": "Bedroom with a ceiling fan, closet doors, and a hallway door.",
        "public_id": "019e84cb-29c3-76ca-a13c-ec894ae411b4",
        "storage_key": "property/6737460151191771/019e84cb-29c3-76ca-a13c-ec894ae411b4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a ceiling fan, plush carpeting, and ample closet space, perfect for relaxation.",
      "link": "",
      "alt_text": "Bedroom with a ceiling fan, closet doors, and a hallway door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f9c2c489-f88e-47ca-9671-855c28d166de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-29d0-7505-82b1-3cb252333d9b.webp",
      "image_media": {
        "alt_text": "Empty garage with an automatic door opener and a closed door.",
        "public_id": "019e84cb-29d0-7505-82b1-3cb252333d9b",
        "storage_key": "property/6737460151191771/019e84cb-29d0-7505-82b1-3cb252333d9b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure your vehicle in our spacious garages, offering ample room for storage.",
      "link": "",
      "alt_text": "Empty garage with an automatic door opener and a closed door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f74eda82-99db-4b07-bcad-dd62facd07f4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-238d-766f-8f67-444c79ceb0cf.webp",
      "image_media": {
        "alt_text": "Leasing center entrance with double blue doors and a sign listing hours of operation.",
        "public_id": "019e84cb-238d-766f-8f67-444c79ceb0cf",
        "storage_key": "property/6737460151191771/019e84cb-238d-766f-8f67-444c79ceb0cf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to our leasing center, conveniently located for all your needs. Visit us during our operating hours for assistance.",
      "link": "",
      "alt_text": "Leasing center entrance with double blue doors and a sign listing hours of operation.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_2394587e-551a-4ebd-840e-b36b1af033cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-28a2-7763-9865-369fc0ef7011.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, stainless steel sink, and double doors leading outside.",
        "public_id": "019e84cb-28a2-7763-9865-369fc0ef7011",
        "storage_key": "property/6737460151191771/019e84cb-28a2-7763-9865-369fc0ef7011.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and airy kitchen featuring ample cabinet space, a double sink, and access to an outdoor area through double doors.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, stainless steel sink, and double doors leading outside.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bc2ec3d1-89c6-40e1-b890-23b01d96279d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-2868-77ff-8f7f-b8e008227b4a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building entrance with a blue door, patio seating, and landscaping.",
        "public_id": "019e84cb-2868-77ff-8f7f-b8e008227b4a",
        "storage_key": "property/6737460151191771/019e84cb-2868-77ff-8f7f-b8e008227b4a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Charming apartment exterior featuring a welcoming blue door, comfortable patio seating, and lush green landscaping, creating an inviting curb appeal.",
      "link": "",
      "alt_text": "Exterior view of apartment building entrance with a blue door, patio seating, and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf980c64-f502-4b06-875e-e93daf59ff02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e84cb-2828-766b-848a-06868590dab3.webp",
      "image_media": {
        "alt_text": "Kitchen with light wood cabinets, black appliances, and dual sink.",
        "public_id": "019e84cb-2828-766b-848a-06868590dab3",
        "storage_key": "property/6737460151191771/019e84cb-2828-766b-848a-06868590dab3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and spacious kitchen featuring light wood cabinetry, a black refrigerator, stove, and a convenient dual sink. Perfect for any home chef.",
      "link": "",
      "alt_text": "Kitchen with light wood cabinets, black appliances, and dual sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_baf9d218-45d6-4e44-8e2c-c42e4fcc665e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Twisted Egg Shack",
      "poi_type": "Restaurants",
      "poi_address": "4318 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Casual spot for breakfast, lunch, bruch and coffee with a drive-thru option.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1f-f5af-7051-b86f-7eec929ca19c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1f-f5af-7051-b86f-7eec929ca19c",
        "storage_key": "property/6737460151191771/019e1e1f-f5af-7051-b86f-7eec929ca19c.webp",
        "width": 1280,
        "height": 1008
      },
      "poi_business_url": "https://twistedeggshack.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4157642139648305122&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "twisted-egg-shack",
      "poi_latitude": "30.1212703",
      "poi_longitude": "-94.162118",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-225-5668",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRyvWzwczOYYR4qfudH_psjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_ad5ecb41-663b-4908-ac04-40a9e5f0e1a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Rao's Bakery",
      "poi_type": "Restaurants",
      "poi_address": "4440 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Long-running local cafe & bakery chain serving coffee, breakfast, sandwiches, gelato & more.",
      "poi_long_description": "Long-running local cafe & bakery chain serving coffee, breakfast, sandwiches, gelato & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-00ad-773a-a78f-7bde34974601.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-00ad-773a-a78f-7bde34974601",
        "storage_key": "property/6737460151191771/019e1e20-00ad-773a-a78f-7bde34974601.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.raosbakery.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10014004094097905444&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "raos-bakery",
      "poi_latitude": "30.1218414",
      "poi_longitude": "-94.1579701",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-347-3400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4YBoGYzOYYRJFcDyKrj-Io",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bakery"
    },
    {
      "id": "custom_6ed1b379-4c40-4f7d-87a6-dd2282a04d08",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Sweet Basil Vietnamese Noodle House",
      "poi_type": "Restaurants",
      "poi_address": "4026 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Noodle soups, banh mi & other classic fare join offbeat starters on the menu at this casual cafe.",
      "poi_long_description": "Noodle soups, banh mi & other classic fare join offbeat starters on the menu at this casual cafe.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1f-f898-725d-bf51-ba8c53bd8ad9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1f-f898-725d-bf51-ba8c53bd8ad9",
        "storage_key": "property/6737460151191771/019e1e1f-f898-725d-bf51-ba8c53bd8ad9.webp",
        "width": 1280,
        "height": 949
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10023669468524900940&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sweet-basil-vietnamese-noodle-house",
      "poi_latitude": "30.1177506",
      "poi_longitude": "-94.1663054",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-347-7594",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa9kCKmkzOYYRTPJaIUY6G4s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_df88c966-ca20-4461-b1c8-f34e4437a56c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Pho BamBoo",
      "poi_type": "Restaurants",
      "poi_address": "4374 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Casual Vietnamese eatery showcasing traditional noodle soups, rice dishes, and small plates.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1f-ff76-703f-9e60-c92abcd156b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1f-ff76-703f-9e60-c92abcd156b7",
        "storage_key": "property/6737460151191771/019e1e1f-ff76-703f-9e60-c92abcd156b7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5665215247924073898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-bamboo",
      "poi_latitude": "30.1207164",
      "poi_longitude": "-94.1598862",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-347-7539",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwTRtuUwzOYYRqhWknEDjnk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_2ad172f1-16d6-45bc-9674-31852b67d460",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Madison's",
      "poi_type": "Restaurants",
      "poi_address": "4020 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Casual fixture with a menu of traditional dishes, plus cocktails, beer and wine on offer.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1f-f620-7009-9636-ec098b887ea2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1f-f620-7009-9636-ec098b887ea2",
        "storage_key": "property/6737460151191771/019e1e1f-f620-7009-9636-ec098b887ea2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://m.facebook.com/pages/Madisons/133063216799902",
      "poi_directions_map_url": "https://maps.google.com/?cid=17645107424769932992&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "madisons",
      "poi_latitude": "30.1176252",
      "poi_longitude": "-94.166404",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-924-9777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47f4-7573-98a2-d7876a9ab1c7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47f4-7573-98a2-d7876a9ab1c7",
        "storage_key": "property/6737460151191771/019e1e20-47f4-7573-98a2-d7876a9ab1c7.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAWkzcGozOYYRwP4EDbcD4PQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_2ab81ada-be04-41c5-b921-ea6688e7f5ef",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "La Cantina Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "4555 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Upbeat venue serving Tex-Mex eats such as fajitas, tacos, and enchiladas plus margaritas and other cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1f-f9c1-7440-b452-ef182b761784.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1f-f9c1-7440-b452-ef182b761784",
        "storage_key": "property/6737460151191771/019e1e1f-f9c1-7440-b452-ef182b761784.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://lacantinamexicangrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12917748045431653302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-cantina-mexican-grill",
      "poi_latitude": "30.1240005",
      "poi_longitude": "-94.1566951",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 409-899-9393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVShdWQzOYYRtkPz-WcPRbM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_298be397-1973-4166-9ae3-c792a413107a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Kikko Ramen & Poke",
      "poi_type": "Restaurants",
      "poi_address": "3050 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Casual Japanese eatery for ramen bowls, poke, bento boxes and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1f-fa7b-729b-ab4c-32ebd3444e4d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1f-fa7b-729b-ab4c-32ebd3444e4d",
        "storage_key": "property/6737460151191771/019e1e1f-fa7b-729b-ab4c-32ebd3444e4d.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "https://www.kikkoramentx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4624351087758847323&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kikko-ramen--poke",
      "poi_latitude": "30.106814",
      "poi_longitude": "-94.1677874",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 409-554-8015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgZGrSOkzOYYRW62OPtD-LEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "japanese_restaurant"
    },
    {
      "id": "custom_f9023da7-2709-47a9-859c-2b352575ad95",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Buffalo Wild Wings",
      "poi_type": "Restaurants",
      "poi_address": "4235 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_long_description": "Chain dishing up wings, tenders & burgers, plus sauces ranging from sweet to very spicy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1f-f61f-73b7-bffb-a7caa651a335.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1f-f61f-73b7-bffb-a7caa651a335",
        "storage_key": "property/6737460151191771/019e1e1f-f61f-73b7-bffb-a7caa651a335.webp",
        "width": 1100,
        "height": 752
      },
      "poi_business_url": "https://www.buffalowildwings.com/locations/us/tx/beaumont/4235-dowlen-road/sports-bar-1249/?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAxNjYxMTc1MS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9621750780190983180&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "buffalo-wild-wings",
      "poi_latitude": "30.1230149",
      "poi_longitude": "-94.1627327",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-924-8646",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJS4hu2mszOYYRDASfOltTh4U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_wings_restaurant"
    },
    {
      "id": "custom_000e438a-34e4-43c9-89fc-0afe955f68b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Chipotle Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "3905 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_long_description": "Casual restaurant offering Mexican fare, including design-your-own burritos, tacos & bowls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1f-f52a-76ac-8f54-38fbb26016d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1f-f52a-76ac-8f54-38fbb26016d7",
        "storage_key": "property/6737460151191771/019e1e1f-f52a-76ac-8f54-38fbb26016d7.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://locations.chipotle.com/tx/beaumont/3905-dowlen-rd?utm_source=google&utm_medium=yext&utm_campaign=yext_listings?restaurant=2871",
      "poi_directions_map_url": "https://maps.google.com/?cid=12693124607350226357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chipotle-mexican-grill",
      "poi_latitude": "30.11537629999999",
      "poi_longitude": "-94.1692845",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-924-0016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ12c0kEzOYYRtT3hTpQJJ7A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_ed34234f-3afd-4eae-a25e-60e13329fff0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Panda Express",
      "poi_type": "Restaurants",
      "poi_address": "4135 Dowlen Rd Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_long_description": "Fast-food chain for Chinese standards, including some health-conscious options.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1f-faed-758a-8b61-8bd9370b7752.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1f-faed-758a-8b61-8bd9370b7752",
        "storage_key": "property/6737460151191771/019e1e1f-faed-758a-8b61-8bd9370b7752.webp",
        "width": 1068,
        "height": 1280
      },
      "poi_business_url": "https://www.pandaexpress.com/locations/tx/beaumont/2646?utm_source=google_gbp&utm_medium=organic&utm_campaign=websitelink",
      "poi_directions_map_url": "https://maps.google.com/?cid=4189764098278894228&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panda-express",
      "poi_latitude": "30.1212486",
      "poi_longitude": "-94.1665125",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-892-1670",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT86F_mszOYYRlCqZwj8IJTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_de84c910-3724-4ed9-81bf-1adba0cdfec4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Mellow Mushroom Beaumont",
      "poi_type": "Restaurants",
      "poi_address": "4375 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Funky, art-filled chain pizzeria featuring craft beer, calzones & creative stone-baked pizzas.",
      "poi_long_description": "Funky, art-filled chain pizzeria featuring craft beer, calzones & creative stone-baked pizzas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-04fd-727c-b898-7882d7490fb4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-04fd-727c-b898-7882d7490fb4",
        "storage_key": "property/6737460151191771/019e1e20-04fd-727c-b898-7882d7490fb4.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.mellowmushroom.com/locations/tx/beaumont/4375-dowlen-road?utm_source=ExtNet&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=17437008837003211900&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mellow-mushroom-beaumont",
      "poi_latitude": "30.1222254",
      "poi_longitude": "-94.1612256",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-347-6469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJT7jKq5ozOYYRfHTs6iaz_PE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_64c3fe50-041e-4fae-9819-52e17344b412",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4050 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_long_description": "Fast-food chain serving chicken sandwiches & nuggets along with salads & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-0438-73ed-b259-5882e144ba47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-0438-73ed-b259-5882e144ba47",
        "storage_key": "property/6737460151191771/019e1e20-0438-73ed-b259-5882e144ba47.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/tx/dowlen-road?utm_source=google&utm_medium=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=2821247464902799229&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "30.1188291",
      "poi_longitude": "-94.167103",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-347-4800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJwR4ybmozOYYRfa8AKZ8VJyc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_40f41cc4-cf3f-4b8f-84a8-15f919aa818c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Jason's Deli",
      "poi_type": "Restaurants",
      "poi_address": "535 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Deli chain featuring specialty sandwiches, salads & other health-conscious fare.",
      "poi_long_description": "Deli chain featuring specialty sandwiches, salads & other health-conscious fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-020e-76f2-86e1-bf868359fe71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-020e-76f2-86e1-bf868359fe71",
        "storage_key": "property/6737460151191771/019e1e20-020e-76f2-86e1-bf868359fe71.webp",
        "width": 1280,
        "height": 623
      },
      "poi_business_url": "https://www.jasonsdeli.com/restaurants/dowlen-road-deli",
      "poi_directions_map_url": "https://maps.google.com/?cid=424176125197461249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jasons-deli",
      "poi_latitude": "30.0804082",
      "poi_longitude": "-94.1720942",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-866-9015",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5dJG6cfMPoYRAaeYQPD54gU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4ade1dcc-8bf4-40aa-9e70-68a1195b4199",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "1701 Barbecue",
      "poi_type": "Restaurants",
      "poi_address": "1701 Calder Ave, Beaumont, TX 77701, USA",
      "poi_short_description": "Casual, homey eatery serving central-Texas-style barbecue of beef brisket, ribs and turkey with sides and sauces.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-05bb-7777-a2c7-77f64c54dc9e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-05bb-7777-a2c7-77f64c54dc9e",
        "storage_key": "property/6737460151191771/019e1e20-05bb-7777-a2c7-77f64c54dc9e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.1701barbecue.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4218009542674918282&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "1701-barbecue",
      "poi_latitude": "30.0856827",
      "poi_longitude": "-94.1126755",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-554-8009",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJjdvOmxLLPoYRiqtYwlRhiTo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_7dbc8513-9cf6-44d9-a1d9-a7c2be7039e8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Tia Juanita's Fish Camp",
      "poi_type": "Restaurants",
      "poi_address": "5555 Calder Ave, Beaumont, TX 77706, USA",
      "poi_short_description": "Casual eatery featuring a menu of Mexican & Cajun-Creole seafood dishes & wood-paneled walls.",
      "poi_long_description": "Casual eatery featuring a menu of Mexican & Cajun-Creole seafood dishes & wood-paneled walls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-0a70-7278-9fd5-4c25d8777711.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-0a70-7278-9fd5-4c25d8777711",
        "storage_key": "property/6737460151191771/019e1e20-0a70-7278-9fd5-4c25d8777711.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.tjfishcamp.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16859989464081880844&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tia-juanitas-fish-camp",
      "poi_latitude": "30.0827582",
      "poi_longitude": "-94.1551762",
      "poi_miles_from_property": "3.9",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-434-4532",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62a7-772e-8170-4aaf32d6a323",
        "storage_key": "property/6737460151191771/019e1e1e-62a7-772e-8170-4aaf32d6a323.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJIRVKlqjMPoYRDNdt6xa3-uk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_62e61ee4-764d-409b-b483-e881e109aea9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "H-E-B plus!",
      "poi_type": "Shopping & Retail",
      "poi_address": "3025 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_long_description": "Branch of a supermarket chain offering groceries, beer & wine, plus a deli, pharmacy & florist.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-0d92-7099-99fc-04e769bf874e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-0d92-7099-99fc-04e769bf874e",
        "storage_key": "property/6737460151191771/019e1e1e-0d92-7099-99fc-04e769bf874e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.heb.com/heb-store/US/tx/beaumont/beaumont-h-e-b-plus--48?utm_source=google&utm_medium=organic&utm_campaign=gmb_stores",
      "poi_directions_map_url": "https://maps.google.com/?cid=2892402008356848458&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "h-e-b-plus",
      "poi_latitude": "30.106625",
      "poi_longitude": "-94.1704312",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 409-866-2007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-6319-722b-8f7f-ffa48e6a0cc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-6319-722b-8f7f-ffa48e6a0cc5",
        "storage_key": "property/6737460151191771/019e1e1e-6319-722b-8f7f-ffa48e6a0cc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0yV90YzOYYRSoO8T03gIyg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f3833c09-a93a-4d0c-a30a-8b7bfa438e4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "3965 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-02c5-725a-a474-ccb81258ffa4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-02c5-725a-a474-ccb81258ffa4",
        "storage_key": "property/6737460151191771/019e1e20-02c5-725a-a474-ccb81258ffa4.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/beaumont/dowlen/034/00325?cid=loc_03400325_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=17788148885970795608&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "30.116851",
      "poi_longitude": "-94.170599",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-899-5925",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-6319-722b-8f7f-ffa48e6a0cc5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-6319-722b-8f7f-ffa48e6a0cc5",
        "storage_key": "property/6737460151191771/019e1e1e-6319-722b-8f7f-ffa48e6a0cc5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJN5pr2mszOYYRWLwMiCoz3PY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_b35b2717-29d1-4098-898c-3e64943d131d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "4145 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Grocery chain with a range of electronics, furniture, toys and clothing options.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-08dc-7327-a703-7077bd96f10c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-08dc-7327-a703-7077bd96f10c",
        "storage_key": "property/6737460151191771/019e1e20-08dc-7327-a703-7077bd96f10c.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/651-beaumont-tx/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10410777979556381375&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "30.1228126",
      "poi_longitude": "-94.16721400000002",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 409-899-9203",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62b2-722d-82a4-718112e3577b",
        "storage_key": "property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJNygOBmwzOYYRv8Lq6mmDepA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_cea64d41-b904-4ddd-87b4-eb1cfb21ec8d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "3885 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-0af9-71e0-90ae-044591c3f8de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-0af9-71e0-90ae-044591c3f8de",
        "storage_key": "property/6737460151191771/019e1e20-0af9-71e0-90ae-044591c3f8de.webp",
        "width": 1280,
        "height": 830
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-3885+dowlen+rd-beaumont-tx-77706/id=6583",
      "poi_directions_map_url": "https://maps.google.com/?cid=609743194417936989&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "30.1145381",
      "poi_longitude": "-94.1693129",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 409-924-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjzx62mszOYYRXTp-azQ-dgg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_7ca14836-d31a-4403-983b-162595b73550",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Exxpress Mart #11",
      "poi_type": "Shopping & Retail",
      "poi_address": "4095 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://exxpressmart.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13406842419819830313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxpress-mart-11",
      "poi_latitude": "30.11942609999999",
      "poi_longitude": "-94.1680451",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 409-892-1551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47c9-76fa-a4f4-d9cd188ebe60.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47c9-76fa-a4f4-d9cd188ebe60",
        "storage_key": "property/6737460151191771/019e1e20-47c9-76fa-a4f4-d9cd188ebe60.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJQ4F8yWszOYYRKdz_-CWsDro",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_2c23c7e0-c5d1-4d95-8dbb-69fb9f2f6a5c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "pOpshelf",
      "poi_type": "Shopping & Retail",
      "poi_address": "4029 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-0b4f-7139-ae46-f0bb7545c287.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-0b4f-7139-ae46-f0bb7545c287",
        "storage_key": "property/6737460151191771/019e1e20-0b4f-7139-ae46-f0bb7545c287.webp",
        "width": 1280,
        "height": 980
      },
      "poi_business_url": "https://www.popshelf.com/store/30093",
      "poi_directions_map_url": "https://maps.google.com/?cid=11415609150270803783&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "popshelf",
      "poi_latitude": "30.11869089999999",
      "poi_longitude": "-94.1707499",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 409-271-3791",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62b2-722d-82a4-718112e3577b",
        "storage_key": "property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJnWnsJ28zOYYRRw-XKApkbJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_0c20c900-bec4-4807-95bb-2b0328d9ecd8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "2602 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-0c6d-73fe-b4bf-24ef9d6bb5f4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-0c6d-73fe-b4bf-24ef9d6bb5f4",
        "storage_key": "property/6737460151191771/019e1e20-0c6d-73fe-b4bf-24ef9d6bb5f4.webp",
        "width": 1280,
        "height": 751
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/tx/beaumont/11472",
      "poi_directions_map_url": "https://maps.google.com/?cid=3806930174614155373&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "30.1025711",
      "poi_longitude": "-94.167814",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 409-234-9432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62b2-722d-82a4-718112e3577b",
        "storage_key": "property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2-N7mUgzOYYRbbCX5tLu1DQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_8521b770-46c5-451d-8359-59a618185c0a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Dollar Tree",
      "poi_type": "Shopping & Retail",
      "poi_address": "229 Dowlen Rd Ste 7, Beaumont, TX 77706, USA",
      "poi_short_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_long_description": "Chain offering a mix of household items, beauty products, food & more at discount prices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-0ed5-752c-a4fd-36efc655002f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-0ed5-752c-a4fd-36efc655002f",
        "storage_key": "property/6737460151191771/019e1e20-0ed5-752c-a4fd-36efc655002f.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://locations.dollartree.com/tx/beaumont/229-dowlen-rd-suite-7?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=14328430403702119087&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-tree",
      "poi_latitude": "30.074963",
      "poi_longitude": "-94.1731899",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 936-274-9005",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62b2-722d-82a4-718112e3577b",
        "storage_key": "property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAz_QycDMPoYRr1qScYnP2MY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_f6eb8f86-e136-4a93-a704-e6a15a70854b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Parkdale Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "6155 Eastex Fwy, Beaumont, TX 77706, USA",
      "poi_short_description": "A variety of stores & eateries line the corridors of this indoor mall with a food court.",
      "poi_long_description": "A variety of stores & eateries line the corridors of this indoor mall with a food court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-1098-7439-b2ea-08ce125b7a03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-1098-7439-b2ea-08ce125b7a03",
        "storage_key": "property/6737460151191771/019e1e1e-1098-7439-b2ea-08ce125b7a03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.parkdalemalltx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12336800100905329862&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "parkdale-mall",
      "poi_latitude": "30.124484",
      "poi_longitude": "-94.1610841",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 409-898-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62b2-722d-82a4-718112e3577b",
        "storage_key": "property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJf49nd2UzOYYRxiR3H1QeNas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_68910a2a-8dc4-47ef-b938-4aa4a45fabe9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Calvary Baptist Church",
      "poi_type": "Education",
      "poi_address": "3650 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-10a8-7175-9325-159db2b3b3e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-10a8-7175-9325-159db2b3b3e4",
        "storage_key": "property/6737460151191771/019e1e20-10a8-7175-9325-159db2b3b3e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://calvaryontheweb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3677650784784000221&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "calvary-baptist-church",
      "poi_latitude": "30.11353519999999",
      "poi_longitude": "-94.1674737",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 409-898-7074",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47cd-709e-a1e0-d1858b5b367e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47cd-709e-a1e0-d1858b5b367e",
        "storage_key": "property/6737460151191771/019e1e20-47cd-709e-a1e0-d1858b5b367e.webp",
        "width": 144,
        "height": 192
      },
      "poi_google_place_id": "ChIJswoZeUEzOYYR3aT8WuejCTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "church"
    },
    {
      "id": "custom_b7706c4e-abcb-4340-bbcf-54bfd8203912",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "All Saints Episcopal School",
      "poi_type": "Education",
      "poi_address": "4108 Delaware St, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-11e6-721c-986a-4d2e44ef9c5f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-11e6-721c-986a-4d2e44ef9c5f",
        "storage_key": "property/6737460151191771/019e1e20-11e6-721c-986a-4d2e44ef9c5f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.allsaints-beaumont.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7964140429751158397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "all-saints-episcopal-school",
      "poi_latitude": "30.1062912",
      "poi_longitude": "-94.1452216",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 409-892-1755",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNwOAs8U1OYYRfQalaIZPhm4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_21448d03-3e5c-4368-963d-cad3e87cd0d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Regina Howell Elementary School",
      "poi_type": "Education",
      "poi_address": "5850 Regina Ln, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bmtisd.com/Regina-Howell",
      "poi_directions_map_url": "https://maps.google.com/?cid=15799978514400170216&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regina-howell-elementary-school",
      "poi_latitude": "30.10211649999999",
      "poi_longitude": "-94.1608144",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-617-6190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVwjuMVAzOYYR6FCgOb_MRNs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_10417ff4-ef54-410c-9a47-49d6201514da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Sallie Curtis Elementary",
      "poi_type": "Education",
      "poi_address": "6225 N Circuit Dr, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bmtisd.com/Curtis",
      "poi_directions_map_url": "https://maps.google.com/?cid=11035775148285303081&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sallie-curtis-elementary",
      "poi_latitude": "30.08866519999999",
      "poi_longitude": "-94.1656794",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-617-6050",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFaEwx7PMPoYRKRmh_gbzJpk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e871e83d-a3b1-4ad5-bc9a-3f6741e73690",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Marshall Middle School",
      "poi_type": "Education",
      "poi_address": "6455 Gladys Ave, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-0ff3-73d9-8130-2696d932b2d6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-0ff3-73d9-8130-2696d932b2d6",
        "storage_key": "property/6737460151191771/019e1e20-0ff3-73d9-8130-2696d932b2d6.webp",
        "width": 719,
        "height": 771
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2426765932202897104&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "marshall-middle-school",
      "poi_latitude": "30.0905926",
      "poi_longitude": "-94.1721592",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 409-617-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb1h4hMrMPoYR0C75_cGarSE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5fa101ac-3441-4945-b356-ead29579c8df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Vincent Middle School",
      "poi_type": "Education",
      "poi_address": "350 Eldridge Dr, Beaumont, TX 77707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7232384578749275169&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vincent-middle-school",
      "poi_latitude": "30.0737955",
      "poi_longitude": "-94.1859798",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-617-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJPWSKT9zMPoYRIRxdn3SXXmQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9bae10a9-ac5e-4e62-a8de-7d0d0119ef8a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "West Brook High School",
      "poi_type": "Education",
      "poi_address": "8750 Phelan Blvd, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-11e5-72b6-9cb0-7ad90f81478d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-11e5-72b6-9cb0-7ad90f81478d",
        "storage_key": "property/6737460151191771/019e1e20-11e5-72b6-9cb0-7ad90f81478d.webp",
        "width": 1140,
        "height": 641
      },
      "poi_business_url": "https://www.bmtisd.com/west%20brook",
      "poi_directions_map_url": "https://maps.google.com/?cid=12611135129857770644&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-brook-high-school",
      "poi_latitude": "30.0785782",
      "poi_longitude": "-94.1974626",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-617-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJf7n42vzNPoYRlESffZXAA68",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_00113d36-91d8-4856-8c60-bcff4e0f0ea9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Monsignor Kelly Catholic High School",
      "poi_type": "Education",
      "poi_address": "5950 Kelly Dr, Beaumont, TX 77707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-1121-71df-9377-d49c7722b953.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-1121-71df-9377-d49c7722b953",
        "storage_key": "property/6737460151191771/019e1e20-1121-71df-9377-d49c7722b953.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://mkchs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12504988784423085352&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "monsignor-kelly-catholic-high-school",
      "poi_latitude": "30.0619173",
      "poi_longitude": "-94.1600851",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-866-2351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJr2miXprMPoYRKCXIjwuliq0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_fa99892e-466c-4e5f-a88c-87c6c7213f36",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Lamar University",
      "poi_type": "Education",
      "poi_address": "4400 S M L King Jr Pkwy, Beaumont, TX 77705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-1693-763c-9535-a13c2da6c158.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-1693-763c-9535-a13c2da6c158",
        "storage_key": "property/6737460151191771/019e1e20-1693-763c-9535-a13c2da6c158.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lamar.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11604622838161463583&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lamar-university",
      "poi_latitude": "30.0415251",
      "poi_longitude": "-94.0754905",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 409-880-7011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy2sEtXjKPoYRH9n_xPzmC6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_98e17a2b-0a2e-4d6f-9679-863a76856487",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Lamar Institute of Technology",
      "poi_type": "Education",
      "poi_address": "855 E Lavaca St, Beaumont, TX 77705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-1452-754d-891c-d57bc4d38126.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-1452-754d-891c-d57bc4d38126",
        "storage_key": "property/6737460151191771/019e1e20-1452-754d-891c-d57bc4d38126.webp",
        "width": 720,
        "height": 540
      },
      "poi_business_url": "https://www.lit.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5301251125442959770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lamar-institute-of-technology",
      "poi_latitude": "30.0460834",
      "poi_longitude": "-94.0784158",
      "poi_miles_from_property": "9.8",
      "poi_walking_minutes": "3 hours 38 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 409-880-8321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnTcPEn3KPoYRmtkqtc_TkUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_44b07991-b797-4143-98e6-8fa8483541c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Crossroads Bowling Center",
      "poi_type": "Entertainment",
      "poi_address": "4370 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Casual family-friendly spot to bowl games or play at the redemption arcade, plus a snack bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-18fc-71fc-8f9d-38078588365a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-18fc-71fc-8f9d-38078588365a",
        "storage_key": "property/6737460151191771/019e1e20-18fc-71fc-8f9d-38078588365a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://crossroadsbowlhiri.wixsite.com/crossroads-1",
      "poi_directions_map_url": "https://maps.google.com/?cid=4100870985590090441&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-bowling-center",
      "poi_latitude": "30.1198218",
      "poi_longitude": "-94.1594716",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 409-899-2695",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJyba7VmYzOYYRyarNHW846Tg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_449d9a6c-b5f9-434b-adaf-7628645e92dc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Regal Star",
      "poi_type": "Entertainment",
      "poi_address": "4455 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-1506-7398-823c-1fd17a427ae7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-1506-7398-823c-1fd17a427ae7",
        "storage_key": "property/6737460151191771/019e1e20-1506-7398-823c-1fd17a427ae7.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-star-1639?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=3961832926009206568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-star",
      "poi_latitude": "30.12296",
      "poi_longitude": "-94.15816",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47cf-70e1-a946-4db2260afb9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47cf-70e1-a946-4db2260afb9f",
        "storage_key": "property/6737460151191771/019e1e20-47cf-70e1-a946-4db2260afb9f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJHT-0OmQzOYYRKKc5Ng5C-zY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b73fe769-1220-42f0-a03d-55c58ce23d44",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Cinemark Beaumont 15 and XD",
      "poi_type": "Entertainment",
      "poi_address": "3855 I-10, Beaumont, TX 77705, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-16a5-7538-9325-924432657e3b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-16a5-7538-9325-924432657e3b",
        "storage_key": "property/6737460151191771/019e1e20-16a5-7538-9325-924432657e3b.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-beaumont/cinemark-beaumont-15-and-xd?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTI5MjktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1833474205784523979&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-beaumont-15-and-xd",
      "poi_latitude": "30.039516",
      "poi_longitude": "-94.152611",
      "poi_miles_from_property": "9.2",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-840-4432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47cf-70e1-a946-4db2260afb9f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47cf-70e1-a946-4db2260afb9f",
        "storage_key": "property/6737460151191771/019e1e20-47cf-70e1-a946-4db2260afb9f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJRWGG7HjMPoYRy8SgdBPPcRk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_d5297a70-9884-4c52-b8c2-c2a3a817cb71",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Julie Rogers Theatre",
      "poi_type": "Entertainment",
      "poi_address": "Julie Rogers Theatre for the Performing Arts, 765 Pearl St, Beaumont, TX 77701, USA",
      "poi_short_description": "Upscale venue for live performances ranging from symphonies to ballets, and recitals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-16aa-71d8-b3fa-64831c2b7f80.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-16aa-71d8-b3fa-64831c2b7f80",
        "storage_key": "property/6737460151191771/019e1e20-16aa-71d8-b3fa-64831c2b7f80.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://beaumonteventstx.com/julie-rogers-theatre-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11413946815982260049&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "julie-rogers-theatre",
      "poi_latitude": "30.08181759999999",
      "poi_longitude": "-94.0960103",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-838-3435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_d8HysXKPoYRUc_Syyd8Zp4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_7c8c793a-8b29-4f49-995e-1b97af4cd6f9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Art Museum of Southeast Texas",
      "poi_type": "Entertainment",
      "poi_address": "500 Main St, Beaumont, TX 77701, USA",
      "poi_short_description": "Museum with permanent & temporary art exhibitions ranging from 19th-century to contemporary works.",
      "poi_long_description": "Museum with permanent & temporary art exhibitions ranging from 19th-century to contemporary works.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-3e3c-7015-beda-48a1c3b62e81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-3e3c-7015-beda-48a1c3b62e81",
        "storage_key": "property/6737460151191771/019e1e1e-3e3c-7015-beda-48a1c3b62e81.webp",
        "width": 1280,
        "height": 771
      },
      "poi_business_url": "http://www.amset.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17768002711062668388&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "art-museum-of-southeast-texas",
      "poi_latitude": "30.083135",
      "poi_longitude": "-94.0974205",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 28 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-832-3432",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-631c-76ba-9a05-1e38e05970b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-631c-76ba-9a05-1e38e05970b7",
        "storage_key": "property/6737460151191771/019e1e1e-631c-76ba-9a05-1e38e05970b7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJA-b8gsXKPoYRZGQRqVOglPY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_3a74348d-aee1-48f7-9293-1b76dc665c02",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Fire Museum of Texas",
      "poi_type": "Entertainment",
      "poi_address": "400 Walnut St, Beaumont, TX 77701, USA",
      "poi_short_description": "Museum displaying exhibits on the history of firefighting & fire safety in a 1927 fire station.",
      "poi_long_description": "Museum displaying exhibits on the history of firefighting & fire safety in a 1927 fire station.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-1433-7528-8104-6f4af5d24b1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-1433-7528-8104-6f4af5d24b1b",
        "storage_key": "property/6737460151191771/019e1e1e-1433-7528-8104-6f4af5d24b1b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://firemuseumoftexas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1881664296886149271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fire-museum-of-texas",
      "poi_latitude": "30.0859308",
      "poi_longitude": "-94.0985742",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 409-880-3927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-631c-76ba-9a05-1e38e05970b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-631c-76ba-9a05-1e38e05970b7",
        "storage_key": "property/6737460151191771/019e1e1e-631c-76ba-9a05-1e38e05970b7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6Q-sc_KPoYRlyBvYrUDHRo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_b90c7430-16b4-4a01-af29-b93befa65cd4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Texas Energy Museum",
      "poi_type": "Entertainment",
      "poi_address": "600 Main St, Beaumont, TX 77701, USA",
      "poi_short_description": "Kid-friendly museum with interactive exhibits on the geology of petroleum & the oil industry.",
      "poi_long_description": "Kid-friendly museum with interactive exhibits on the geology of petroleum & the oil industry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-1a75-76b7-8f8b-382e81fc25f7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-1a75-76b7-8f8b-382e81fc25f7",
        "storage_key": "property/6737460151191771/019e1e20-1a75-76b7-8f8b-382e81fc25f7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.texasenergymuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1496075029223532695&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "texas-energy-museum",
      "poi_latitude": "30.0823777",
      "poi_longitude": "-94.0964486",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-833-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-631c-76ba-9a05-1e38e05970b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-631c-76ba-9a05-1e38e05970b7",
        "storage_key": "property/6737460151191771/019e1e1e-631c-76ba-9a05-1e38e05970b7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8_vPjcXKPoYRl2gzAlAgwxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_2b003561-ff02-4835-86c3-9d484e689a98",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Spindletop Gladys-City Boomtown Museum",
      "poi_type": "Entertainment",
      "poi_address": "5550 Jimmy Simmons Blvd, Beaumont, TX 77705, USA",
      "poi_short_description": "Visitors tour buildings, such as a saloon & post office, in this recreated turn-of-the-century town.",
      "poi_long_description": "Visitors tour buildings, such as a saloon & post office, in this recreated turn-of-the-century town.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-1a7c-701f-8d45-213f04e78ff6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-1a7c-701f-8d45-213f04e78ff6",
        "storage_key": "property/6737460151191771/019e1e20-1a7c-701f-8d45-213f04e78ff6.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "http://spindletop.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15480861697095116552&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spindletop-gladys-city-boomtown-museum",
      "poi_latitude": "30.0326274",
      "poi_longitude": "-94.0790742",
      "poi_miles_from_property": "10.7",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 409-880-1750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-631c-76ba-9a05-1e38e05970b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-631c-76ba-9a05-1e38e05970b7",
        "storage_key": "property/6737460151191771/019e1e1e-631c-76ba-9a05-1e38e05970b7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJmX13PnDKPoYRCCdOQLER19Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_bf5b768b-8a81-4d59-8e61-50bb8755d817",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Beaumont Children's Museum",
      "poi_type": "Entertainment",
      "poi_address": "701 Main St, Beaumont, TX 77701, USA",
      "poi_short_description": "Hands-on exhibits & activities for kids, including a miniature town, puppet theater & toddler area.",
      "poi_long_description": "Hands-on exhibits & activities for kids, including a miniature town, puppet theater & toddler area.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-168f-75c2-96e6-0dca80a4bcd9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-168f-75c2-96e6-0dca80a4bcd9",
        "storage_key": "property/6737460151191771/019e1e1e-168f-75c2-96e6-0dca80a4bcd9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.beaumontchildrensmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6532536021749499517&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-childrens-museum",
      "poi_latitude": "30.0825952",
      "poi_longitude": "-94.0956128",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-347-7919",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-631c-76ba-9a05-1e38e05970b7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-631c-76ba-9a05-1e38e05970b7",
        "storage_key": "property/6737460151191771/019e1e1e-631c-76ba-9a05-1e38e05970b7.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-YI9CsbKPoYRfYbSouY6qFo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_81e47ff9-6a77-42b4-a10e-5f78705dc017",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "AFC Urgent Care - Beaumont",
      "poi_type": "Health and Wellness",
      "poi_address": "3195 Dowlen Rd Ste105, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-1f90-77f9-aeb7-704f6ce41b17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-1f90-77f9-aeb7-704f6ce41b17",
        "storage_key": "property/6737460151191771/019e1e20-1f90-77f9-aeb7-704f6ce41b17.webp",
        "width": 256,
        "height": 250
      },
      "poi_business_url": "https://www.afcurgentcare.com/beaumont/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-beaumont-gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=9266620837043353686&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care---beaumont",
      "poi_latitude": "30.1090603",
      "poi_longitude": "-94.1691341",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 409-860-1888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT24S3kYzOYYRVrgz_I2mmYA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_20e67b8c-6c34-403e-9722-e8dcc92dfc2e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Dowlen Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "2342 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-205f-727a-9cef-cb406b6466a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-205f-727a-9cef-cb406b6466a8",
        "storage_key": "property/6737460151191771/019e1e20-205f-727a-9cef-cb406b6466a8.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "http://www.dowlenmedicalcenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1835154436355452006&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dowlen-urgent-care",
      "poi_latitude": "30.0981843",
      "poi_longitude": "-94.169363",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 409-861-0000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJw6dr5kgzOYYRZuzynjzHdxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_f699c285-e7ca-4f9d-8b7f-2efd27f3b7c0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "2950 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-06f4-751c-9607-8a90c64931aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-06f4-751c-9607-8a90c64931aa",
        "storage_key": "property/6737460151191771/019e1e20-06f4-751c-9607-8a90c64931aa.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/beaumont-tx-pharmacies/2950-dowlen-rd-beaumont-tx-77706/storeid=8351?WT.mc_id=LS_GOOGLE_RX_8351",
      "poi_directions_map_url": "https://maps.google.com/?cid=5584284434403103684&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "30.10523449999999",
      "poi_longitude": "-94.167609",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 409-861-3413",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47cc-717d-8d6f-cc3ef886fe90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47cc-717d-8d6f-cc3ef886fe90",
        "storage_key": "property/6737460151191771/019e1e20-47cc-717d-8d6f-cc3ef886fe90.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJd6sEGkYzOYYRxBNXNRtdf00",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9a0c4693-5c16-4885-9330-23b6686f08aa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "4145 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-21bb-744a-8784-18747aa2823e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-21bb-744a-8784-18747aa2823e",
        "storage_key": "property/6737460151191771/019e1e20-21bb-744a-8784-18747aa2823e.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/651-beaumont-tx/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=11238881094536022605&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "30.1228126",
      "poi_longitude": "-94.16721400000002",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 409-899-3615",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47cc-717d-8d6f-cc3ef886fe90.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47cc-717d-8d6f-cc3ef886fe90",
        "storage_key": "property/6737460151191771/019e1e20-47cc-717d-8d6f-cc3ef886fe90.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6RYFFmkzOYYRTUqsMM-G-Js",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9b41427c-46fa-4d7c-8d82-6a79cc5cc286",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Crunch Fitness - Beaumont",
      "poi_type": "Health and Wellness",
      "poi_address": "4191 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Part of a chain, this gym at Parkdale Mall offers group fitness classes, cardio machines, and personal training.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-15d6-70dd-aff6-4e17196e0626.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-15d6-70dd-aff6-4e17196e0626",
        "storage_key": "property/6737460151191771/019e1e1e-15d6-70dd-aff6-4e17196e0626.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.crunch.com/locations/beaumont",
      "poi_directions_map_url": "https://maps.google.com/?cid=15152827820138571283&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crunch-fitness---beaumont",
      "poi_latitude": "30.124155",
      "poi_longitude": "-94.1649471",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 409-240-9868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIyHwFzIzOYYREyYEip6oSdI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_c898a92f-c67c-4ec2-9784-ba4a05b97f67",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "World Gym Beaumont",
      "poi_type": "Health and Wellness",
      "poi_address": "229 Dowlen Rd #5, Beaumont, TX 77706, USA",
      "poi_short_description": "Friendly, spacious fitness center featuring machines and classes as well as personal training and child care facilities.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-1d37-74a7-9064-91892c4c4def.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-1d37-74a7-9064-91892c4c4def",
        "storage_key": "property/6737460151191771/019e1e1e-1d37-74a7-9064-91892c4c4def.webp",
        "width": 992,
        "height": 1280
      },
      "poi_business_url": "https://www.worldgym.com/beaumont/home",
      "poi_directions_map_url": "https://maps.google.com/?cid=18379234589123791042&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "world-gym-beaumont",
      "poi_latitude": "30.075157",
      "poi_longitude": "-94.1732356",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-866-5595",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx2wFrsDMPoYRwshLQHsoEP8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_7629a4c9-3551-4204-a131-fa9a5351711f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "HOTWORX - Beaumont, TX",
      "poi_type": "Health and Wellness",
      "poi_address": "3195 Dowlen Rd #104, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-2224-74b0-b685-b72c7bcfde25.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-2224-74b0-b685-b72c7bcfde25",
        "storage_key": "property/6737460151191771/019e1e20-2224-74b0-b685-b72c7bcfde25.webp",
        "width": 554,
        "height": 312
      },
      "poi_business_url": "https://www.hotworx.net/studio/beaumont?utm_source=google&utm_medium=organic&utm_campaign=gbp",
      "poi_directions_map_url": "https://maps.google.com/?cid=17335164291713758975&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---beaumont-tx",
      "poi_latitude": "30.1089113",
      "poi_longitude": "-94.1690484",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 409-730-7001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJubvA8DozOYYR_3ai4hPgkvA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "yoga_studio"
    },
    {
      "id": "custom_aaf4f069-6bca-4639-a9fc-c2f6bc44a600",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Penché Pilates - Reformer Pilates Studio",
      "poi_type": "Health and Wellness",
      "poi_address": "5905 Phelan Blvd suite e, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-2971-709b-9b31-27cc4bea5242.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-2971-709b-9b31-27cc4bea5242",
        "storage_key": "property/6737460151191771/019e1e20-2971-709b-9b31-27cc4bea5242.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://penchepilates.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=733511214223843469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pench-pilates---reformer-pilates-studio",
      "poi_latitude": "30.0797694",
      "poi_longitude": "-94.1638888",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-550-9032",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcfmeTgDNPoYRjeCTIpD0LQo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9131a14e-16fa-4188-abfa-4c01d2e9cd8b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Roger's Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1455 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Verdant public park featuring play structures, athletic fields & courts, a pool & paved walkways.",
      "poi_long_description": "Verdant public park featuring play structures, athletic fields & courts, a pool & paved walkways.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-2f8b-76ac-bb3e-5dd164f8b40e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-2f8b-76ac-bb3e-5dd164f8b40e",
        "storage_key": "property/6737460151191771/019e1e1e-2f8b-76ac-bb3e-5dd164f8b40e.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://www.beaumontcvb.com/things-to-do/outdoor-recreation/city-parks/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3132855800486934296&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rogers-park",
      "poi_latitude": "30.0917911",
      "poi_longitude": "-94.1727692",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 409-861-1929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-6306-7779-90ff-b801baa02330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-6306-7779-90ff-b801baa02330",
        "storage_key": "property/6737460151191771/019e1e1e-6306-7779-90ff-b801baa02330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJX7mqt8rMPoYRGLeLgMAjeis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_7b4dec9f-a211-41a8-ae5b-bc90d453388a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Ida Reed Dog Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2348 Louisiana Ave, Beaumont, TX 77702, USA",
      "poi_short_description": "Large, fenced dog park, divided into sides for big and small dogs: some have agility items.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-22ff-72ea-90c8-75b6b53d47aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-22ff-72ea-90c8-75b6b53d47aa",
        "storage_key": "property/6737460151191771/019e1e20-22ff-72ea-90c8-75b6b53d47aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.beaumontcvb.com/listing/ida-reed-dog-park/609/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10360613162637023831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ida-reed-dog-park",
      "poi_latitude": "30.0950725",
      "poi_longitude": "-94.1219766",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 409-861-1929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-6306-7779-90ff-b801baa02330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-6306-7779-90ff-b801baa02330",
        "storage_key": "property/6737460151191771/019e1e1e-6306-7779-90ff-b801baa02330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJVrRN800OYYRV1o3TsdKyI8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dog_park"
    },
    {
      "id": "custom_ea556bc8-cf1d-4042-9c84-2766d3a8317a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Tyrrell Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6088 Babe Zaharias Dr, Beaumont, TX 77705, USA",
      "poi_short_description": "Park featuring an 18-hole golf course, a walking trail, picnic tables, basketball & a playground.",
      "poi_long_description": "Park featuring an 18-hole golf course, a walking trail, picnic tables, basketball & a playground.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-2e52-7517-ab5f-34e6cba4762e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-2e52-7517-ab5f-34e6cba4762e",
        "storage_key": "property/6737460151191771/019e1e20-2e52-7517-ab5f-34e6cba4762e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.beaumontcvb.com/listing/tyrrell-park/591/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15514593030987533916&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tyrrell-park",
      "poi_latitude": "30.0240744",
      "poi_longitude": "-94.1459543",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-838-3613",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-6306-7779-90ff-b801baa02330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-6306-7779-90ff-b801baa02330",
        "storage_key": "property/6737460151191771/019e1e1e-6306-7779-90ff-b801baa02330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9S8-IffLPoYRXE7DbinoTtc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_92025906-46dc-4e1c-b7f9-d6d26662fbe6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Beaumont Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6088 Babe Zaharias Dr, Beaumont, TX 77705, USA",
      "poi_short_description": "Outdoor themed gardens with paved pathways & a sizable conservatory featuring tropical plants.",
      "poi_long_description": "Outdoor themed gardens with paved pathways & a sizable conservatory featuring tropical plants.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-1f45-709e-bf47-9307e5095f92.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-1f45-709e-bf47-9307e5095f92",
        "storage_key": "property/6737460151191771/019e1e20-1f45-709e-bf47-9307e5095f92.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.bbgtx.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2969575974138253370&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-botanical-gardens",
      "poi_latitude": "30.0241875",
      "poi_longitude": "-94.1461741",
      "poi_miles_from_property": "9.9",
      "poi_walking_minutes": "3 hours 40 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 409-842-3135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq-V-w_DLPoYROpALcJ0NNik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_717544e6-78af-444b-afcf-148d98715aa5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Cattail Marsh Scenic Wetlands & Boardwalk",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "4233 Babe Zaharias Dr, Beaumont, TX 77705, USA",
      "poi_short_description": "900-acre wildlife refuge boasting 8+ miles of trails, many bird species & scenic wetland boardwalks.",
      "poi_long_description": "900-acre wildlife refuge boasting 8+ miles of trails, many bird species & scenic wetland boardwalks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-2635-76aa-8e1d-9e43385e35a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-2635-76aa-8e1d-9e43385e35a2",
        "storage_key": "property/6737460151191771/019e1e20-2635-76aa-8e1d-9e43385e35a2.webp",
        "width": 1280,
        "height": 940
      },
      "poi_business_url": "https://www.beaumontcvb.com/things-to-do/cattail-marsh/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8653479357311170084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cattail-marsh-scenic-wetlands--boardwalk",
      "poi_latitude": "30.0069411",
      "poi_longitude": "-94.1425628",
      "poi_miles_from_property": "11.1",
      "poi_walking_minutes": "4 hours 6 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 409-554-2447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt-oKY_vLPoYRJDa1m6BVF3g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hiking_area"
    },
    {
      "id": "custom_75f8a06f-bfba-44b5-a291-ae878cfd0608",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Rotary Centennial Playground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "600 Crockett St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-2aef-71a9-adbe-a578127330ae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-2aef-71a9-adbe-a578127330ae",
        "storage_key": "property/6737460151191771/019e1e20-2aef-71a9-adbe-a578127330ae.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.beaumontcvb.com/listing/rotary-centennial-playground/1443/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17157388048149145565&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rotary-centennial-playground",
      "poi_latitude": "30.0819358",
      "poi_longitude": "-94.1019439",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 23 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJr0hi9NrKPoYR3Wd2q4ZJG-4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_fa72f7d7-c171-4333-b12b-ed586b33a372",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Downtown Event Centre",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "700 Crockett St, Beaumont, TX 77701, USA",
      "poi_short_description": "Event venue with a fountain and a playground popular for family vacations.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-2a10-757a-9452-753d7da59c7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-2a10-757a-9452-753d7da59c7a",
        "storage_key": "property/6737460151191771/019e1e20-2a10-757a-9452-753d7da59c7a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://beaumonteventstx.com/downtown-event-centre-info/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16833389512485063214&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-event-centre",
      "poi_latitude": "30.0811702",
      "poi_longitude": "-94.1030924",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-838-3435",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF-VKTtrKPoYRLkp1EZM2nOk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_44ed1ab7-7b25-45e1-ae77-99ce8c9e6531",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Beautiful Mountain Skate Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "999 Laurel Ave, Beaumont, TX 77701, USA",
      "poi_short_description": "Destination for skateboarding, plus scooters, and remote-control cars.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-2ae7-7465-b173-00f958f399cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-2ae7-7465-b173-00f958f399cf",
        "storage_key": "property/6737460151191771/019e1e20-2ae7-7465-b173-00f958f399cf.webp",
        "width": 1280,
        "height": 1064
      },
      "poi_business_url": "http://beaumonttexas.gov/departments/parks-recreation/beautiful-mountain-skate-plaza-2/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6321753611585889777&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beautiful-mountain-skate-park",
      "poi_latitude": "30.082748",
      "poi_longitude": "-94.1038281",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-861-1929",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4XAeDdrKPoYR8aUeaGphu1c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "skateboard_park"
    },
    {
      "id": "custom_41232b4a-c5d7-4c60-9355-1404bff4477f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Village Creek State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8854 Park Rd 74, Lumberton, TX 77657, USA",
      "poi_short_description": "A forest, cypress swamps & a creek offering opportunity for birding, camping, fishing & canoeing.",
      "poi_long_description": "A forest, cypress swamps & a creek offering opportunity for birding, camping, fishing & canoeing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-2f4d-74b6-9f84-2d1ab8e5f76c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-2f4d-74b6-9f84-2d1ab8e5f76c",
        "storage_key": "property/6737460151191771/019e1e20-2f4d-74b6-9f84-2d1ab8e5f76c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://tpwd.texas.gov/state-parks/village-creek",
      "poi_directions_map_url": "https://maps.google.com/?cid=16206846029889582398&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "village-creek-state-park",
      "poi_latitude": "30.2504771",
      "poi_longitude": "-94.1786889",
      "poi_miles_from_property": "11",
      "poi_walking_minutes": "3 hours 59 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 409-755-7322",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-6306-7779-90ff-b801baa02330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-6306-7779-90ff-b801baa02330",
        "storage_key": "property/6737460151191771/019e1e1e-6306-7779-90ff-b801baa02330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJpdT2EbgwOYYRPrUEvZhI6uA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "state_park"
    },
    {
      "id": "custom_80a1d458-5641-4242-9266-d6e761a1cef3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "McFaddin National Wildlife Refuge",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5632 Clam Lake Rd, Sabine Pass, TX 77655, USA",
      "poi_short_description": "Waterfowl habitat with opportunities for fishing, hunting, wildlife-watching & photography.",
      "poi_long_description": "Waterfowl habitat with opportunities for fishing, hunting, wildlife-watching & photography.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-2ff5-7739-a1ca-9e6f51c8c586.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-2ff5-7739-a1ca-9e6f51c8c586",
        "storage_key": "property/6737460151191771/019e1e20-2ff5-7739-a1ca-9e6f51c8c586.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fws.gov/refuge/McFaddin/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8895382142759459657&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mcfaddin-national-wildlife-refuge",
      "poi_latitude": "29.6696593",
      "poi_longitude": "-94.0752368",
      "poi_miles_from_property": "48.2",
      "poi_walking_minutes": "17 hours 27 mins",
      "poi_biking_minutes": "4 hours 18 mins",
      "poi_driving_minutes": "57 mins",
      "poi_business_phone": "+1 409-971-2909",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-6306-7779-90ff-b801baa02330.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-6306-7779-90ff-b801baa02330",
        "storage_key": "property/6737460151191771/019e1e1e-6306-7779-90ff-b801baa02330.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJu0THo7W5PoYRSduH2O2-cns",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wildlife_refuge"
    },
    {
      "id": "custom_c041198c-dc4a-44f5-9900-33ffab265234",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Dannenbaum Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-32ab-7658-9aaf-42f8d61890ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-32ab-7658-9aaf-42f8d61890ff",
        "storage_key": "property/6737460151191771/019e1e20-32ab-7658-9aaf-42f8d61890ff.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=3413697703500096818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dannenbaum-station",
      "poi_latitude": "30.0837749",
      "poi_longitude": "-94.1029586",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-4822-761f-b9d8-472c32f31eca.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-4822-761f-b9d8-472c32f31eca",
        "storage_key": "property/6737460151191771/019e1e20-4822-761f-b9d8-472c32f31eca.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJJzeLgdDKPoYRMqWwi_njXy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_station"
    },
    {
      "id": "custom_ab3f5597-a1e9-4c10-bc7e-81083596f042",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Beaumont Municipal Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "550 Milam St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.beaumonttransit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14088195377303785302&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-municipal-transit",
      "poi_latitude": "30.0773579",
      "poi_longitude": "-94.0961769",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-835-7895",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-624d-70f4-9060-6a3ca3fa97f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-624d-70f4-9060-6a3ca3fa97f4",
        "storage_key": "property/6737460151191771/019e1e1e-624d-70f4-9060-6a3ca3fa97f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh5hI7sPKPoYRVg9-ng1Tg8M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_17db62c2-a1b7-4099-8b33-9cdaaeb6d169",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Beaumont Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2555 W Cedar St, Beaumont, TX 77704, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-2c55-74ba-bd89-41b606d9e7ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-2c55-74ba-bd89-41b606d9e7ab",
        "storage_key": "property/6737460151191771/019e1e1e-2c55-74ba-bd89-41b606d9e7ab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=BMT",
      "poi_directions_map_url": "https://maps.google.com/?cid=11900572941090476785&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-station",
      "poi_latitude": "30.0763445",
      "poi_longitude": "-94.1276121",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62af-73bc-8db1-e303c2923f6d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62af-73bc-8db1-e303c2923f6d",
        "storage_key": "property/6737460151191771/019e1e1e-62af-73bc-8db1-e303c2923f6d.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJMylntTjLPoYR8dJSuQlUJ6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_22206836-0c15-4ef8-9d91-44339f85e658",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Greyhound",
      "poi_type": "Transportation & Transit",
      "poi_address": "1055 Interstate 10 Access Rd, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.greyhound.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9963284059869115085&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound",
      "poi_latitude": "30.0677164",
      "poi_longitude": "-94.133502",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ50Y5TwDLPoYRzXLPkBCyRIo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_87fa7f22-05ad-45b7-a7d4-5e2c56ec4c3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Jack Brooks Regional Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "US-69, Beaumont, TX 77705, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-3aa6-717d-9669-cdddbc0cb542.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-3aa6-717d-9669-cdddbc0cb542",
        "storage_key": "property/6737460151191771/019e1e20-3aa6-717d-9669-cdddbc0cb542.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://flysetx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2176126301825167048&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jack-brooks-regional-airport",
      "poi_latitude": "29.955004",
      "poi_longitude": "-94.01843",
      "poi_miles_from_property": "17.3",
      "poi_walking_minutes": "6 hours 22 mins",
      "poi_biking_minutes": "1 hour 33 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "+1 409-719-4900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-635b-74c9-aac9-7484ac14f807.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-635b-74c9-aac9-7484ac14f807",
        "storage_key": "property/6737460151191771/019e1e1e-635b-74c9-aac9-7484ac14f807.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJwVqa1-K2PoYRyG6shlcnMx4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_2d2cc82b-3570-442f-b64d-4134d7773703",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Dowlen Towne Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "3939 Dowlen Rd, Beaumont, TX 77706, USA",
      "poi_short_description": "Shopping mall featuring discount prices on brand-name apparel and footwear.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-34ca-756e-9c7a-2582663efd41.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-34ca-756e-9c7a-2582663efd41",
        "storage_key": "property/6737460151191771/019e1e20-34ca-756e-9c7a-2582663efd41.webp",
        "width": 1280,
        "height": 1159
      },
      "poi_business_url": "http://properties.kimcorealty.com/properties/0444A/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8164617247887965452&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dowlen-towne-center",
      "poi_latitude": "30.1166051",
      "poi_longitude": "-94.170457",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-62b2-722d-82a4-718112e3577b",
        "storage_key": "property/6737460151191771/019e1e1e-62b2-722d-82a4-718112e3577b.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJS4hu2mszOYYRDL1jAyGMTnE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_63d6b8c9-1687-41c4-b94f-99fc55a59334",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Baptist Hospitals of Southeast Texas",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3080 College St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-2220-729e-a7f4-fc2202b6d38c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-2220-729e-a7f4-fc2202b6d38c",
        "storage_key": "property/6737460151191771/019e1e1e-2220-729e-a7f4-fc2202b6d38c.webp",
        "width": 1200,
        "height": 630
      },
      "poi_business_url": "https://www.bhset.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5776751231773483408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "baptist-hospitals-of-southeast-texas",
      "poi_latitude": "30.0708582",
      "poi_longitude": "-94.1199575",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-212-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-6360-776f-8a7c-ee1882a43e02.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-6360-776f-8a7c-ee1882a43e02",
        "storage_key": "property/6737460151191771/019e1e1e-6360-776f-8a7c-ee1882a43e02.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJy60PcxjLPoYRkKGohaMkK1A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_aa457c70-b134-4f7c-8ab1-def612103322",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "CHRISTUS Southeast Texas - St. Elizabeth",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2830 Calder Ave, Beaumont, TX 77702, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-23ee-73cf-8676-1f0416a5e2f2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-23ee-73cf-8676-1f0416a5e2f2",
        "storage_key": "property/6737460151191771/019e1e20-23ee-73cf-8676-1f0416a5e2f2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.christushealth.org/locations/southeast-texas-st-elizabeth?utm_source=GBP&utm_medium=organic&utm_campaign=GBP-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=331253752832100405&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christus-southeast-texas---st-elizabeth",
      "poi_latitude": "30.086832",
      "poi_longitude": "-94.131897",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 409-892-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJq2OMmUnLPoYRNYgSfIjZmAQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_f80d8165-dabe-4b5c-a635-6a0b9a224cc9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Beaumont Independent School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3395 Harrison Ave, Beaumont, TX 77706, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-3aa0-72fb-921b-fea119241996.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-3aa0-72fb-921b-fea119241996",
        "storage_key": "property/6737460151191771/019e1e20-3aa0-72fb-921b-fea119241996.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.bmtisd.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14236380487007692350&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-independent-school-district",
      "poi_latitude": "30.0887436",
      "poi_longitude": "-94.1378638",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 409-617-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e20-47de-73bb-90ec-e9c228401492",
        "storage_key": "property/6737460151191771/019e1e20-47de-73bb-90ec-e9c228401492.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS8tBFEzLPoYRPmZlF6DIkcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6900c277-48e0-483b-a015-936feca8de4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Port of Beaumont",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1225 Main St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-3b4c-709b-988f-f0c2f8b11f78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-3b4c-709b-988f-f0c2f8b11f78",
        "storage_key": "property/6737460151191771/019e1e20-3b4c-709b-988f-f0c2f8b11f78.webp",
        "width": 1280,
        "height": 800
      },
      "poi_business_url": "http://www.pobtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12772425836873736407&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "port-of-beaumont",
      "poi_latitude": "30.0793794",
      "poi_longitude": "-94.09233",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 409-835-5367",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-624d-70f4-9060-6a3ca3fa97f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-624d-70f4-9060-6a3ca3fa97f4",
        "storage_key": "property/6737460151191771/019e1e1e-624d-70f4-9060-6a3ca3fa97f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbzB0f8DKPoYR12DhnqDFQLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_8953afb4-3ee9-4b3a-8ef7-e30354062c1b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Exxon Mobil Refinery",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1795 Burt St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-3cce-75ac-93c5-3dcf2f58d3b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-3cce-75ac-93c5-3dcf2f58d3b7",
        "storage_key": "property/6737460151191771/019e1e20-3cce-75ac-93c5-3dcf2f58d3b7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.exxonmobilpipeline.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4788597052635653166&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "exxon-mobil-refinery",
      "poi_latitude": "30.065081",
      "poi_longitude": "-94.073392",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 22 mins",
      "poi_biking_minutes": "52 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 409-757-3295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ44Y3rJvKPoYRLqTU9qWDdEI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_4a8e2a7c-50a7-4ae3-a792-653e3dafe177",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Jefferson County Court House",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1149 Pearl St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-3b99-7119-ab4f-894852a4d877.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-3b99-7119-ab4f-894852a4d877",
        "storage_key": "property/6737460151191771/019e1e20-3b99-7119-ab4f-894852a4d877.webp",
        "width": 1280,
        "height": 780
      },
      "poi_business_url": "http://www.co.jefferson.tx.us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7553340734335509551&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jefferson-county-court-house",
      "poi_latitude": "30.0787684",
      "poi_longitude": "-94.0929888",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 409-835-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-624d-70f4-9060-6a3ca3fa97f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-624d-70f4-9060-6a3ca3fa97f4",
        "storage_key": "property/6737460151191771/019e1e1e-624d-70f4-9060-6a3ca3fa97f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_bebx8bKPoYRL2SO6WDb0mg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "courthouse"
    },
    {
      "id": "custom_207a6176-cf88-41da-bacb-837a46e1dd4e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Beaumont ,TX City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "801 Main St, Beaumont, TX 77701, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-3036-762e-bd50-319eb44cd304.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e1e-3036-762e-bd50-319eb44cd304",
        "storage_key": "property/6737460151191771/019e1e1e-3036-762e-bd50-319eb44cd304.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://beaumonttexas.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5870285382313414587&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beaumont-tx-city-hall",
      "poi_latitude": "30.0816671",
      "poi_longitude": "-94.0946262",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 409-980-8311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-624d-70f4-9060-6a3ca3fa97f4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-624d-70f4-9060-6a3ca3fa97f4",
        "storage_key": "property/6737460151191771/019e1e1e-624d-70f4-9060-6a3ca3fa97f4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ4btbsbKPoYRu4_1_nNxd1E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_acd5271d-ebaa-422a-8218-d75325f90473",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "poi_name": "Valero Port Arthur Refinery",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1801 S Gulfway Dr, Port Arthur, TX 77640, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e20-41d4-7474-9b6d-a63dd2e220dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019e1e20-41d4-7474-9b6d-a63dd2e220dd",
        "storage_key": "property/6737460151191771/019e1e20-41d4-7474-9b6d-a63dd2e220dd.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.valero.com/about/locations/port-arthur-refinery",
      "poi_directions_map_url": "https://maps.google.com/?cid=15990012572720462434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valero-port-arthur-refinery",
      "poi_latitude": "29.86535099999999",
      "poi_longitude": "-93.9633946",
      "poi_miles_from_property": "24.6",
      "poi_walking_minutes": "8 hours 57 mins",
      "poi_biking_minutes": "2 hours 7 mins",
      "poi_driving_minutes": "30 mins",
      "poi_business_phone": "+1 409-985-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019e1e1e-629d-718d-bdbe-1ef5aa12578c",
        "storage_key": "property/6737460151191771/019e1e1e-629d-718d-bdbe-1ef5aa12578c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb3qwgvK6PoYRYnoIV7fv590",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    }
  ],
  "office_hours": [
    {
      "id": "ec_6dc48ac6af520fd8910f0709",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_069036e49ce7453b56e1aa23",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_80799ab2cc1074f6f075c63b",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_f3ef5e49783f981a660b1d39",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_d90008559d8c189db3f24ee3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_4f17d0fb-ca71-4551-ad46-1dd304c0f390",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "rating": "5.0",
      "name": "Robert Gillespie Sr.",
      "text": "Handle the issue in a timely manner",
      "date": "2026-05-01",
      "title": ""
    },
    {
      "id": "custom_8f500565-1581-44cd-bcdc-2cc12613a684",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "rating": "5.0",
      "name": "Katy Jackson",
      "text": "I like living here they are kind, welcoming and helpful here. Also the l maintenance people are great at their jobs and they are kind, understanding, give helpful explanations, respond timely and always fix things perfectly. Kal fixed my door perfectly. Everyone is great here.",
      "date": "2026-05-01",
      "title": ""
    },
    {
      "id": "custom_fee64064-8cb4-452f-9719-d0bb20b8e641",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "rating": "5.0",
      "name": "Johnny lee Trevino",
      "text": "Keily Sutton was amazing, kind and sweet very direct and welcoming to a new town and cozy apartment",
      "date": "2026-04-24",
      "title": ""
    },
    {
      "id": "custom_ad514562-b7ed-4185-8ee2-b15a79a08fcf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "rating": "5.0",
      "name": "Steve Robinson",
      "text": "Today I woke up to a clogged toilet nightmare. I submitted a work order and in under an hour Kalvin responded. In less than 10 minutes he troubleshot and fixed the problem. Complete Professional!",
      "date": "2026-04-10",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_e7cad30e-238f-4c75-bbce-ee4d86f96a1e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019e1e1d-f1cd-706a-9867-3da36c90b33d.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019e1e1d-f1cd-706a-9867-3da36c90b33d",
        "storage_key": "property/6737460151191771/019e1e1d-f1cd-706a-9867-3da36c90b33d.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Swimming Pool",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=66baa681d95486483bc9f2e9"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01993ff2-7313-7776-93ce-afc3f5e89e4c",
      "lead_source": "LANDING_PAGE",
      "name": "rr-living-the-pointe-lp",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771"
    },
    {
      "lead_collector_id": "019a5029-8d99-717f-a725-808bb9091ab1",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rreaf-the-pointe-new",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771"
    },
    {
      "lead_collector_id": "019d6350-da3a-718c-8a29-05967e70df1e",
      "lead_source": "FACEBOOK_ADS",
      "name": "Facebook Ads",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "page_item_url": "apartments-with-pool-beaumont-tx",
      "search_query": "apartments with a pool Beaumont TX",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Beaumont, TX",
      "h2_subtitle": "Dive into comfort at The Pointe, offering apartments in Beaumont, TX with a sparkling pool. Experience leisure and luxury in one vibrant community.",
      "page_copy": "Welcome to The Pointe, where our Beaumont, TX apartments offer a refreshing lifestyle enhanced by our stunning pool. Imagine relaxing by the water on a sunny day or taking a swim to unwind after a long day. Our community is thoughtfully designed to provide residents with premium amenities, including a fitness center and picnic area, making it a perfect place to call home.\n\nLocated in the heart of North Beaumont, The Pointe offers more than just apartments; it offers a community lifestyle. With walking and biking trails surrounding the area, and gated access for peace of mind, you can enjoy both the tranquility and excitement of Beaumont living. Schedule a tour today and explore our available spacious floor plans to find your ideal new apartment with a pool.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with covered entrance and garages.",
        "public_id": "019d076f-5fc1-7118-816e-065174b44974",
        "storage_key": "property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Beaumont, TX",
      "seo_description": "Discover top-notch Beaumont, TX apartments with a pool at The Pointe. Enjoy modern amenities, spacious floor plans, and a refreshing lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "page_item_url": "fitness-center-apartments-north-beaumont",
      "search_query": "fitness center apartments North Beaumont",
      "category": "Amenity",
      "h1_title": "Fitness Center Apartments in North Beaumont",
      "h2_subtitle": "Discover The Pointe, where fitness center apartments await in North Beaumont. Enjoy a healthy lifestyle with our state-of-the-art facilities.",
      "page_copy": "At The Pointe, we understand the importance of maintaining a healthy lifestyle. That's why our fitness center apartments in North Beaumont provide residents with access to top-notch equipment anytime. Whether you're starting your day with a workout or winding down in the gym, you'll find everything you need right at home.\n\nBeyond our fully-equipped fitness center, our community offers additional amenities like a pool, business center, and picnic area. Nestled in the vibrant North Beaumont neighborhood, The Pointe provides a perfect blend of convenience and comfort. Explore our spacious one and two-bedroom floor plans and make The Pointe your new home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with covered entrance and garages.",
        "public_id": "019d076f-5fc1-7118-816e-065174b44974",
        "storage_key": "property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Fitness Center Apartments North Beaumont",
      "seo_description": "Live healthy at The Pointe in North Beaumont. Our apartments offer a fitness center, pool, and spacious floor plans for an active lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "page_item_url": "playground-equipped-apartments-jefferson-county",
      "search_query": "playground equipped apartments Jefferson County",
      "category": "Amenity",
      "h1_title": "Playground Apartments in Jefferson County",
      "h2_subtitle": "Experience family-friendly living at The Pointe, offering playground-equipped apartments in Jefferson County for fun and relaxation.",
      "page_copy": "Welcome to The Pointe, where our playground-equipped apartments in Jefferson County are designed with families in mind. Our community provides a safe and fun play area for children, promoting outdoor activity and social engagement. Along with the playground, residents enjoy amenities like a pool and picnic area, creating the perfect environment for relaxation and leisure.\n\nLocated in the welcoming neighborhood of North Beaumont, The Pointe combines comfort, convenience, and community living. Our spacious one and two-bedroom floor plans are ideal for families looking for a vibrant and secure place to call home. Visit us today to find your family's next apartment in Jefferson County!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with covered entrance and garages.",
        "public_id": "019d076f-5fc1-7118-816e-065174b44974",
        "storage_key": "property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Playground Apartments in Jefferson County",
      "seo_description": "Discover The Pointe, offering playground apartments in Jefferson County. Perfect for families, with top-notch amenities and spacious living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-beaumont-77706",
      "search_query": "smoke free apartments in Beaumont 77706",
      "category": "Amenity",
      "h1_title": "Smoke Free Apartments in Beaumont 77706",
      "h2_subtitle": "Breathe easy at The Pointe, offering smoke free apartments in Beaumont's 77706 area. Enjoy a clean, refreshing community lifestyle.",
      "page_copy": "At The Pointe in the heart of Beaumont's 77706 area, we offer a healthy and refreshing living environment with our smoke-free apartments. Enjoy a residence where clean air and comfort take precedence, providing a peaceful atmosphere for all our residents. Choose from our range of spacious one and two-bedroom floor plans and discover the difference a smoke-free lifestyle can make.\n\nOur community is more than just smoke-free; it comes with an array of amenities designed to enhance your living experience. With a fitness center, pool, and walking trails, there's something for everyone. Located in North Beaumont, The Pointe offers the perfect blend of serene living and city convenience. Visit us today to find your new smoke-free home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with covered entrance and garages.",
        "public_id": "019d076f-5fc1-7118-816e-065174b44974",
        "storage_key": "property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke Free Apartments Beaumont 77706",
      "seo_description": "The Pointe in Beaumont 77706 offers smoke-free living with top amenities. Enjoy fresh air in our spacious, serene community apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "page_item_url": "hardwood-floor-apartments-beaumont-tx",
      "search_query": "hardwood floor apartments Beaumont TX",
      "category": "Amenity",
      "h1_title": "Hardwood Floor Apartments in Beaumont, TX",
      "h2_subtitle": "Discover the elegance of hardwood floor apartments at The Pointe in Beaumont, TX. Enjoy stylish living with modern amenities and spacious designs.",
      "page_copy": "The Pointe offers stunning hardwood floor apartments in Beaumont, TX, perfect for those seeking stylish and modern living. These beautiful floors add a touch of elegance to our spacious one and two-bedroom apartments, giving a warm and inviting feeling to your home. Experience the blend of classic design with contemporary convenience in our vibrant community.\n\nAside from eye-catching interiors, The Pointe provides exceptional amenities such as a pool, fitness center, and picnic area, making it an ideal choice for residents who appreciate both style and function. Located in the bustling North Beaumont neighborhood, you'll enjoy easy access to local highlights while retreating to the comfort of your hardwood-floored home. Visit us today to see why The Pointe is the perfect place for sophisticated living in Beaumont.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with covered entrance and garages.",
        "public_id": "019d076f-5fc1-7118-816e-065174b44974",
        "storage_key": "property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hardwood Floor Apartments Beaumont, TX",
      "seo_description": "Explore The Pointe's hardwood floor apartments in Beaumont, TX. Enjoy modern amenities and stylish living spaces in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "page_item_url": "two-bedroom-floorplans-north-beaumont",
      "search_query": "two bedroom floorplans north beaumont",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Floorplans in North Beaumont",
      "h2_subtitle": "Explore spacious two-bedroom floorplans at The Pointe, located in North Beaumont. Your ideal living space awaits in our vibrant community.",
      "page_copy": "Welcome to The Pointe, where you can explore our versatile two-bedroom floorplans in the thriving North Beaumont area. Perfect for growing families or roommates, each apartment is designed to offer spacious living areas with ample room for both comfort and privacy. Embrace the opportunity to create your ideal home environment in one of our thoughtfully designed residences.\n\nBeyond the inviting interiors, residents benefit from a host of exceptional amenities. Unwind by the pool, stay active with the fitness center, or take leisurely strolls along our walking trails. Situated in North Beaumont, The Pointe offers easy access to local shops, dining, and entertainment, ensuring you have everything you need right at your doorstep. Discover the perfect two-bedroom floorplan at The Pointe today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with covered entrance and garages.",
        "public_id": "019d076f-5fc1-7118-816e-065174b44974",
        "storage_key": "property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Floorplans North Beaumont",
      "seo_description": "Discover spacious two-bedroom floorplans at The Pointe in North Beaumont. Perfect for comfortable living in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6737460151191771",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-jefferson-county",
      "search_query": "one bedroom apartments jefferson county",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Jefferson County",
      "h2_subtitle": "Discover the perfect one-bedroom apartments at The Pointe in Jefferson County. Enjoy modern living with top amenities in a welcoming community.",
      "page_copy": "Find your perfect one-bedroom apartment in Jefferson County at The Pointe, where every detail is designed with your lifestyle in mind. Our one-bedroom floorplans cater to individuals seeking a cozy yet spacious living environment, featuring modern amenities and contemporary designs that enhance comfort and convenience.\n\nSituated in the picturesque area of North Beaumont, The Pointe provides residents with easy access to the best of Jefferson County. Enjoy a refreshing dip in the pool, work up a sweat in our fitness center, or relax in our beautifully maintained picnic areas. With our location, you’re never far from local dining, shopping, and entertainment. Visit The Pointe today and discover a community that feels like home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
      "featured_image_media": {
        "alt_text": "Exterior view of apartment building with covered entrance and garages.",
        "public_id": "019d076f-5fc1-7118-816e-065174b44974",
        "storage_key": "property/6737460151191771/019d076f-5fc1-7118-816e-065174b44974.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments Jefferson County",
      "seo_description": "Explore one-bedroom apartments in Jefferson County at The Pointe. Modern living with top amenities in a friendly community environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "3358"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "5028483584"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4709053"
    },
    {
      "ID": "custom_best_of_logo",
      "type": "BOOLEAN",
      "value": "true"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NGFVCTCW"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "409-345-2378"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "409-345-2271"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "409-345-2057"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "409-345-2866"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "409-345-2114"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "409-377-6816"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "409-345-2552"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "409-345-2543"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "409-377-6952"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "409-215-3263"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "409-359-8325"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "409-345-2530"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "409-908-4759"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "409-547-7445"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "409-547-7737"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "409-405-4977"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "409-345-2360"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "409-547-7301"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "4271722839"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "409-345-2374"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "409-419-4231"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "11ee60997fc81b44"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "409-547-7831"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "409-345-2351"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "409-345-2370"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "409-263-5983"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "409-345-2871"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "409-345-2305"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "409-345-2538"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.thepointeapthome.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6737460151191771/019e84cb-ea0b-775b-9db6-f15360f644fb.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "409-345-2528"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "409-215-3263"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "3358",
  "custom_repli_id": "5028483584",
  "custom_realpage_id": "4709053",
  "custom_best_of_logo": "true",
  "custom_knock_a_link": "https://www.thepointeapthome.com?utm_knock=a",
  "custom_knock_g_link": "https://www.thepointeapthome.com?utm_knock=g",
  "custom_knock_r_link": "https://www.thepointeapthome.com?utm_knock=r",
  "custom_knock_w_link": "https://www.thepointeapthome.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-NGFVCTCW",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.thepointeapthome.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.thepointeapthome.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.thepointeapthome.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.thepointeapthome.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.thepointeapthome.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.thepointeapthome.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "409-345-2378",
  "custom_knock_ads_link": "https://www.thepointeapthome.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.thepointeapthome.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "409-345-2271",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.thepointeapthome.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.thepointeapthome.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.thepointeapthome.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.thepointeapthome.com?utm_knock=psa",
  "custom_knock_r_number": "409-345-2057",
  "custom_knock_w_number": "409-345-2866",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "409-345-2114",
  "custom_knock_amap_link": "https://www.thepointeapthome.com?utm_knock=amap",
  "custom_knock_ar_number": "409-377-6816",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "409-345-2552",
  "custom_knock_fb_number": "409-345-2543",
  "custom_knock_fl_number": "409-377-6952",
  "custom_knock_gp_number": "409-215-3263",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.thepointeapthome.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "409-359-8325",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.thepointeapthome.com?utm_knock=bcard",
  "custom_knock_bnr_number": "409-345-2530",
  "custom_knock_cfres_link": "https://www.thepointeapthome.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "409-908-4759",
  "custom_knock_lgp_number": "409-547-7445",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.thepointeapthome.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "409-547-7737",
  "custom_knock_psa_number": "409-405-4977",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "409-345-2360",
  "custom_knock_bandit_link": "https://www.thepointeapthome.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.thepointeapthome.com?utm_knock=flyers",
  "custom_knock_osoc_number": "409-547-7301",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "4271722839",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "409-345-2374",
  "custom_knock_cfres_number": "409-419-4231",
  "custom_knock_chatgpt_link": "https://www.thepointeapthome.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "11ee60997fc81b44",
  "custom_knock_dirmail_link": "https://www.thepointeapthome.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "409-547-7831",
  "custom_knock_propbro_link": "https://www.thepointeapthome.com?utm_knock=propbro",
  "custom_knock_bandit_number": "409-345-2351",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "409-345-2370",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.thepointeapthome.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "409-263-5983",
  "custom_knock_dirmail_number": "409-345-2871",
  "custom_knock_propbro_number": "409-345-2305",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "409-345-2538",
  "custom_knock_maintenance_link": "https://www.thepointeapthome.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6737460151191771/019e84cb-ea0b-775b-9db6-f15360f644fb.mp4",
  "custom_knock_maintenance_number": "409-345-2528",
  "custom_ppc_tracking_phone_number": "409-215-3263"
};

export const generatedAt = '2026-10-07T17:15:14.006Z';
